import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { phoneValidation } from "validationSchemas/common";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import { showSuccess, showError } from "toast/toast";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import Select, { SingleValue, components } from "react-select";
import { License, Office, Agent, Addresses, Address, Product, PaymentMethod, PaymentGateway, StatusHistoryItem, PaymentInfoItem, Supplier, Addresstax } from "types";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import PaymentFormManualOrder from "../../components/PaymentFormManualOrder";
import { InstallationStatusBadge } from "components/Installationstatus";
import { StatusBadge } from "components/Productlocationstatus";
import PaymentMethods from "components/PaymentMethods";
import RealtorProductPicker from "components/installationpop";
import InstallationStatusTracker from "components/InstallationStatusTracker";
import SectionHeader from "components/SectionPillPropsIcons";
import PostTypeSignConfiguration, {
    type InstallationPostPayload,
    type PostTypeSignConfigurationRef,
} from "pages/signage/PostTypeSignConfiguration";
import { GENERAL_SETTINGS_KEYS } from "pages/signage/SignageGeneralSettings";
import type { LinkedProduct } from "components/ProductSelectionModal";
import CompactApprovedProofCard from "components/CompactApprovedProofCard";
import OrderInvoice from "components/OrderInvoice";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios, { all } from "axios";
import OrderLog, { buildInstallationLogEventsFromOrder } from "../../components/OrderLog";
import Instructions from "components/Instructions";
import ProductSelection from "assets/images/brands/ProductSelection.png"
import Doller from "assets/images/brands/doller.png"
import PaymentPanel from "components/PaymentOptionsCard";
import ProofSection, { ProofFile } from "../../components/ProofOfInstallation";
import type { InvoiceType } from "components/InvoiceDocument";
import AddressAutocomplete from "components/AddressAutocomplete";
import SpecialFeeui from "components/Tax/InstallationandremovalSpecialfeeui";
import PONumber from "components/PONumber";
import { handleApiError } from "utils/errorHandler";
import { safeConsole, createSafeNavigate } from "utils/envUtils";
import { batchPresignUrls } from "components/Imageshelper";
import { getImageSrc, useVariantImageUrlMap } from "components/Tableimageshelpers";
import {
    getCustomizationsBlockFromLineItem,
    getVisibleCustomizationFieldsForDisplay,
    resolveSelectedLineItemForDisplay,
} from "utils/installationProductCustomizationDisplay";
import {
    buildInstallationLineItemImages,
    isMeaningfulObjectId,
    normalizeInstallationLineItemImages,
} from "utils/buildInstallationLineItemImages";
import {
    requestInstallationTaxRefund,
    type Product as TaxProduct,
} from "components/Tax/INstallationandRemovalsTaxEngine";
import {
    postInstallationOrderResolve,
    buildInstallationResolvePayload,
    buildInstallationEditResolveLineItems,
    applyInstallationEditResolveResponse,
    getResolvedDiscountDisplay,
    getOrderDiscountFieldDisplay,
    type InstallationResolveAddress,
    getInstallationResolveRootDiscountCode,
    inferInstallationDiscountScope,
    inferInstallationDiscountScopeFromResolved,
    splitInstallationDiscountForPayload,
    mapInstallationSpecialFeeForResolve,
    mapInstallationSpecialFeeForSubmit,
    mapSavedInstallationSpecialFeeToUi,
    normalizeInstallationSelectedFee,
    mapInstallationOrderLinesToResolved,
    type OrderResolveAction,
    type ResolvedInstallationLineItem,
    type ResolvedInstallationOrder,
    buildInstallationPatchFromResolved,
} from "orderResolve";
import { OrderDiscountCodeField } from "components/orderResolve";
import { sendInstallationOrderTriggerEmail } from "utils/salesOrderTriggerEmailEngine";
import { buildSpecialFeeCostBreakdownDisplay } from "utils/specialFeeCostBreakdownDisplay";
// TaxCloud helpers
import {
    PostVersionOrdernumber,
    GetVersionOrdernumber,
} from "components/Tax/InstallationandRemovalTaxcloud";
import { getAuthCookie } from "../../utils/authCookies";
import { buildLoggedInPaymentPaidBy } from "../../utils/buildPaymentPaidBy";
import { installationPartyIdentityFromSavedOrder, sanitizeInstallationOrderSubmitPayload, buildInstallationDetailsParticipantFields } from "../../utils/installationPartyIdentity";
import {
    fetchProjectApprovedMessage,
    fetchInstallationOrderById,
    patchInstallationOrder,
    postInstallationOrderAction,
    postInstallationOrderPayment,
    getInstallationImageUploadUrl,
    resolveInstallationSellerOrganizationId,
    resolveInstallationSellerMembershipId,
    resolveInstallationAddressMembershipId,
    resolveInstallationVendorSelectOption,
    resolveInstallationInstallerSelectOption,
    mergeInstallationOrderBillingAddress,
    persistSupplierOrganizationId,
    fetchInstallationPaymentMethods,
    resolveInstallationPaymentMethodsMembershipId,
    fetchInstallationPaymentGateway,
    createInstallationStripePaymentIntent,
    postInstallationDynamicCost,
    installationOrderUrls,
    installationRequest,
    sessionLicenseFromAuthCookies,
    fetchUserAddresses,
    fetchGeneralSettings,
} from "api/installationApi";
import { appendPermissionsFalse } from "api/salesOrderApi";
import { downloadWorkDriveFile } from "api/realesyStudioApi";
import { formatLineDiscountAmount } from "components/DiscountLabelBadge";
import {
    computeInstallationUnitsCostFromChangedUnitPrice,
    getInstallationLineChangedUnitCostTotal,
    getInstallationLineDiscountDisplay,
    orderLineKey,
} from "utils/orderResolveLinePricing";
// Active tax type
import { getActiveTaxType } from "components/Tax/manualtax";
type Selected = {
    value: string;
    label: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

type ProductObj = {
    product_id: string;
    agent_id: string;
    office_id: string;
    inventory_type: string;
    product: Product;
    linked_installer_details: any
    created_by: {
        id: string;
        name: string;
    };
};
export type FlattenedProduct = {
    product_id: string;
    name: string;
    sku: string;
    inventory_type: "agent" | "office" | string;
    product_location_status?: string;
    user_id?: string;
    product_current_status?: string;
    current_status?: string;
    availableqty: number;
    quantity: number;
    updateStatus?: string;
    productionStatus?: string;
    image_url?: string;
    location?: Array<{
        quantity: number;
        warehouse_id: string;
        warehouse_name?: string;
        zone_id?: string;
        zone_name?: string;
        rack_id?: string;
        rack_name?: string;
        bin_id?: string;
        bin_name?: string;
    }>;
    storage_locations?: Array<{
        quantity: number;
        current_status: string;
        location?: Array<{
            quantity: number;
            warehouse_id: string;
            warehouse_name?: string;
            zone_id?: string;
            zone_name?: string;
            rack_id?: string;
            rack_name?: string;
            bin_id?: string;
            bin_name?: string;
        }>;
    }>;
    is_accessory?: boolean;
    is_new_purchase?: boolean;
    source_product_id?: string | null;
    is_production?: boolean;
    unit_price?: number;
    unit_retail_price?: number;
    changed_unit_price?: number;
    total_price?: number;
    item_sub_total?: number;
    discount?: number;
    discount_on_total_quantity?: number;
    /** Studio customization â€” from installation order line item */
    design_id?: string;
    design_name?: string;
    preview_url?: string;
    images?: Array<{ url: string; alt_text?: string; default?: boolean }>;
    /** Per line_item from API — template answers for Product Selection */
    customizations?: unknown;
    /** Free-form agent/office details for custom inventory lines */
    custom_information?: string;
    /** Backend slot id for post-type sign configuration */
    slot_id?: string;
    /** Logical slot key (e.g. main_panel) — set when adding via Post Type config */
    slotKey?: string;
    variant_id?: string;
    is_new_catalog?: boolean;
    /** Mirrors API `is_accessories` when present */
    is_accessories?: boolean;
    is_taxable?: boolean;
};


async function fetchNewUniqueId(token: string): Promise<string> {
    const url = `${process.env.REACT_APP_API_URL}/utils/new-unique-id`;
    const res = await fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) throw new Error("Failed to generate unique id");
    const data = await res.json();
    return String(data?.id ?? data?._id ?? data ?? "");
}

function normalizeSlotIdValue(id: unknown): string {
    if (id == null || id === "") return "";
    if (typeof id === "object") {
        const oid = (id as { $oid?: string }).$oid;
        if (oid) return String(oid).trim();
        const str = (id as { toString?: () => string }).toString?.();
        return str && str !== "[object Object]" ? String(str).trim() : "";
    }
    return String(id).trim();
}

function isProductInSlot(
    product: { slotKey?: string; slot_id?: unknown; is_accessory?: boolean },
    slotKey: string,
    slotId?: string
): boolean {
    if (product.is_accessory || slotKey === "accessory") return false;
    const normSlotId = normalizeSlotIdValue(slotId);
    const pSlotKey = String(product.slotKey ?? "").trim();
    const pSlotId = normalizeSlotIdValue(product.slot_id);
    if (pSlotKey && pSlotKey === slotKey) return true;
    if (normSlotId && pSlotId && pSlotId === normSlotId) return true;
    return false;
}

/** Show a readable label for generated custom-product SKUs. */
function displayInstallationSku(item: { sku?: string; custom_sku?: string; inventory_type?: string; inventory_source?: string }): string {
    const src = String(item.inventory_type ?? item.inventory_source ?? "");
    if (src !== "custom") return String(item.sku ?? "");

    const customSku = String(item.custom_sku ?? item.sku ?? "").trim();
    if (!customSku) return "";

    if (/^custom_sku(?:_|$)/i.test(customSku)) {
        return "Custom SKU";
    }

    return customSku;
}

/** Match signage work order display: show address parts from address_details instead of only the label. */
function formatInstallationAddressForDisplay(address?: Addresses | null): string {
    const details = address?.address_details;
    if (!details) return "";

    return [
        details.addressLine1,
        details.addressLine2,
        details.city,
        details.state,
        details.zip
    ].filter(Boolean).join(", ");
}

const libraries: Array<"places"> = ["places"];
const apiKey: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

const mapContainerStyle = {
    width: "100%",
    height: "350px",
    borderRadius: "12px",
    overflow: "hidden",
    // boxShadow: "0 0 10px rgba(0,0,0,0.1)", // Soft shadow
    // border: "1px solid #dee2e6",          // Light border
};

const center = {
    lat: 40.712776, // Default latitude (e.g., New York City)
    lng: -74.005974, // Default longitude
};
/** Hide arrow when disabled */
const DropdownIndicator = (props: any) => {
    if (props.selectProps.isDisabled) return null;
    return (
        <components.DropdownIndicator {...props}>
            <i className="ri-arrow-down-s-line fs-5" style={{ color: "#6c757d" }} />
        </components.DropdownIndicator>
    );
};

const customSelectStyles = {
    /* hide all indicators when disabled */
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        display: state.isDisabled ? "none" : "flex",
    }),
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        display: state.isDisabled ? "none" : "flex",
    }),
    indicatorSeparator: () => ({ display: "none" }),

    /* keep bg and cursor right; do NOT fade */
    control: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isDisabled ? "#f2f2f2" : provided.backgroundColor,
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        opacity: 1,
    }),

    /* â€”â€”â€” make text BLACK when disabled â€”â€”â€” */
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "#000" : provided.color,
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "#000" : provided.color,
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "#000" : provided.color,
        WebkitTextFillColor: state.isDisabled ? "#000" : undefined, // Safari
    }),
    placeholder: (provided: any, state: any) => ({
        ...provided,
        /* if field has no value, keep placeholder readable too */
        color: state.isDisabled ? "#000" : provided.color,
    }),

    /* if you ever use isMulti, keep chips readable */
    multiValue: (p: any, s: any) => ({
        ...p,
        backgroundColor: s.isDisabled ? "#e5e7eb" : p.backgroundColor,
    }),
    multiValueLabel: (p: any, s: any) => ({
        ...p,
        color: s.isDisabled ? "#000" : p.color,
    }),
    multiValueRemove: (p: any, s: any) => ({
        ...p,
        display: s.isDisabled ? "none" : p.display,
    }),
};

type InstallationTaxEngineHandle = {
    recalculate: (forceType?: "manual" | "taxcloud", options?: { allowRefund?: boolean }) => Promise<boolean>;
};

/**
 * Some installation-order GET responses wrap the document as `{ data: order }`.
 * If `data` looks like an order (has id or order_number), use it so fields like
 * `uploaded_files` are not stuck on the wrong nesting level.
 */
function normalizeInstallationOrderFetchPayload(raw: unknown): any {
    if (!raw || typeof raw !== "object") return raw;
    const r = raw as Record<string, unknown>;
    const inner = r.data;
    if (
        inner &&
        typeof inner === "object" &&
        !Array.isArray(inner) &&
        Boolean((inner as any)._id || (inner as any).id || (inner as any).order_number)
    ) {
        return inner;
    }
    return raw;
}

/** Backend may send instruction attachments as `uploaded_files` or `uploadedFiles`. */
function getInstructionUploadedFilesFromOrder(order: unknown): any[] {
    if (!order || typeof order !== "object") return [];
    const o = order as Record<string, unknown>;
    const snake = o.uploaded_files;
    const camel = o.uploadedFiles;
    if (Array.isArray(snake) && snake.length > 0) return snake as any[];
    if (Array.isArray(camel) && camel.length > 0) return camel as any[];
    if (Array.isArray(snake)) return snake as any[];
    if (Array.isArray(camel)) return camel as any[];
    return [];
}

const AgentViewInstallation = () => {
    const { installationId } = useParams<{ installationId: string }>();
    const location = useLocation();
    const type = location.state?.type ?? "View"; // 
    const mode = (type || "View").toLowerCase() as "view" | "edit";
    const isEdit = mode === "edit";
    const Viewmode = !isEdit;
    const token = getAuthCookie("sessionToken");
    const membershipId = getAuthCookie("membershipId") || "";
    const globalUserId = getAuthCookie("globalUserId") || "";
    const organizationId = getAuthCookie("organizationId") || "";
    const userId = membershipId;
    const userName = getAuthCookie("userName");
    const licenseType = getAuthCookie("licenseType");
    const [allAvailableSpecialFees, setAllAvailableSpecialFees] = useState<any[]>([]);
    const [selectedSpecialFees, setSelectedSpecialFees] = useState<any[]>([]); // âœ… State for special fees
    const [preview, setPreview] = useState<string | null>(null);
    const [ordernumber, setOrderNumber] = useState<string | null>(null);

    // Tax type state
    const [taxType, setTaxType] = useState<"manual" | "taxcloud" | "unknown">("unknown");
    const [taxCloudFinalized, setTaxCloudFinalized] = useState(false);
    const [isRecomputing, setIsRecomputing] = useState(false);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [quantity, setQuantity] = useState(1);
    const [addressObjects, setAddressObjects] = useState<any[]>([]);
    const [suppliers, setSuppliers] = useState<Supplier[]>([])
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [productObjs, setProductObjs] = useState<ProductObj[]>([]);
    const [selectedProductOption, setSelectedProductOption] = useState<any | null>(null);
    const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
    const [installationPost, setInstallationPost] = useState<InstallationPostPayload | null>(null);
    const [customProductSettingEnabled, setCustomProductSettingEnabled] = useState(false);
    const postTypeConfigRef = React.useRef<PostTypeSignConfigurationRef | null>(null);
    const isPurchasedInstallationLine = (product: Partial<FlattenedProduct>) => {
        const inventorySource = String(product?.inventory_type || "").trim().toLowerCase();
        return Boolean(product?.is_new_purchase) || inventorySource === "custom";
    };
    const [installationCost, setInstallationCost] = useState<number | null>(null);
    const [totalUnits, setTotalUnits] = useState<number>(0);
    const [uploadedFileMeta, setUploadedFileMeta] = useState<ProofFile[]>([]);
    const [instructionFileUrlMap, setInstructionFileUrlMap] = useState<Record<string, string>>({});
    const [imagePreviews, setImagePreviews] = useState<string[]>([]);
    const [previewFiles, setPreviewFiles] = useState<{ file: File; url: string }[]>([]);
    const [isMarkerDraggable, setIsMarkerDraggable] = useState(false);
    const [installationOrder, setInstallationOrder] = useState<any>();
    const [approvedMessageData, setApprovedMessageData] = useState<any>(null);
    const [hasApprovedMessage, setHasApprovedMessage] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod[]>([]);
    const [payment, setPayment] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<{ name: string; _id: string } | null>(null);
    const [clientSecret, setClientSecret] = useState<string | "">();
    const [userInfo, setUserInfo] = useState<License>();
    const [pickerOpen, setPickerOpen] = useState(false);
    const closePicker = () => setPickerOpen(false);
    const [instructions, setInstructions] = useState<string>("");
    const installationTaxRef = React.useRef<InstallationTaxEngineHandle | null>(null);
    const lastResolvedInstallationRef = useRef<ResolvedInstallationOrder | null>(null);
    const rows = useMemo(
        () => selectedProducts.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== ""),
        [selectedProducts]
    );

    /** Stable list for PostTypeSignConfiguration view mode (post type with linked product images per slot); same as SignageInstallationWorkOrder */
    const viewModeLineItemsForPost = useMemo(
        () =>
            selectedProducts
                ?.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== "")
                ?.map((p) => ({
                    slot_id: p.slot_id,
                    is_accessory: !!(p.is_accessory ?? p.is_accessories),
                    images: p.images || [],
                })) ?? [],
        [selectedProducts]
    );


    /** Products with slot assignments — hydrates Post Type edit UI from existing line items */
    const editModeHydrationProducts = useMemo(
        () =>
            selectedProducts
                ?.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== "")
                ?.map((p) => ({
                    slot_id: p.slot_id,
                    slotKey: p.slotKey,
                    is_accessory: !!(p.is_accessory ?? p.is_accessories),
                    product_id: String(p.product_id ?? ""),
                    name: p.name,
                    sku: p.sku,
                    variant_id: p.variant_id,
                    images: p.images,
                    image_url: p.image_url,
                }))
                ?.filter((p) => p.product_id) ?? [],
        [selectedProducts]
    );

    /** Current selection for Avl Qty consumption in ProductSelectionModal. */
    const selectedStockLines = useMemo(
        () =>
            (selectedProducts || [])
                .map((p) => {
                    const product_id = String(p.product_id ?? "").trim();
                    if (!product_id) return null;
                    const src = String(p.inventory_type || p.inventory_source || "").toLowerCase();
                    if (src === "custom" || src === "rotational") return null;
                    return {
                        product_id,
                        variant_id: p.variant_id != null ? String(p.variant_id).trim() : "",
                        quantity: Number(p.quantity) || 1,
                    };
                })
                .filter(Boolean) as Array<{ product_id: string; variant_id?: string; quantity: number }>,
        [selectedProducts]
    );

    /**
     * Original order line qtys (edit mode). API available often excludes stock already
     * on this order; baseline returns that qty to Avl when the user removes a line.
     */
    const baselineStockLines = useMemo(() => {
        const toId = (raw: any) => {
            if (raw == null) return "";
            if (typeof raw === "object") return String(raw.$oid || raw.toString?.() || "").trim();
            return String(raw).trim();
        };
        return (installationOrder?.line_items || [])
            .map((li: any) => {
                const product_id = toId(li?.product_id);
                if (!product_id) return null;
                const src = String(li?.inventory_source || li?.inventory_type || "").toLowerCase();
                if (src === "custom" || src === "rotational") return null;
                return {
                    product_id,
                    variant_id: toId(li?.variant_id),
                    quantity: Number(li?.quantity) || 1,
                };
            })
            .filter(Boolean) as Array<{ product_id: string; variant_id?: string; quantity: number }>;
    }, [installationOrder?.line_items]);


    useEffect(() => {
        const ip = installationOrder?.installation_post;
        if (ip?.post_type_id) {
            setInstallationPost(ip as InstallationPostPayload);
        }
    }, [installationOrder?.installation_post?.post_type_id]);

    useEffect(() => {
        if (!token) return;
        fetchGeneralSettings(token)
            .then((data: { results?: { key: string; enabled: boolean }[] }) => {
                const list = Array.isArray(data?.results) ? data.results : [];
                const custom = list.find((s) => s.key === GENERAL_SETTINGS_KEYS.CUSTOM_PRODUCT);
                setCustomProductSettingEnabled(custom?.enabled ?? false);
            })
            .catch(() => setCustomProductSettingEnabled(false));
    }, [token]);

    const customizationWorkDriveFileIds = useMemo(() => {
        const HEX = /^[a-f0-9]{24}$/i;
        const ids: string[] = [];
        for (const p of selectedProducts || []) {
            const block = getCustomizationsBlockFromLineItem(p);
            const fields = Array.isArray((block as { fields?: unknown[] })?.fields)
                ? ((block as { fields: unknown[] }).fields as Array<{ field_type?: string; value?: unknown }>)
                : [];
            for (const f of fields) {
                const t = String(f?.field_type || "").toLowerCase();
                const v = String(f?.value ?? "").trim();
                if ((t === "file" || t === "image") && v && HEX.test(v)) ids.push(v);
            }
        }
        return Array.from(new Set(ids));
    }, [selectedProducts]);

    const customizationImageUrlMapData = useMemo(
        () =>
            customizationWorkDriveFileIds.length === 0
                ? []
                : [{ product: { variants: [{ images: customizationWorkDriveFileIds.map((url) => ({ url })) }] } }],
        [customizationWorkDriveFileIds]
    );
    const customizationImageUrlMap = useVariantImageUrlMap(customizationImageUrlMapData as any, token);

    const updateProducts = (next: FlattenedProduct[]) => {
        setSelectedProducts(next);
        // onProductsChange?.(next);
    };

    const handleAddFromPicker = async (flattened: FlattenedProduct) => {
        const hasSlotAssignment = Boolean(flattened.slotKey && flattened.slotKey !== "accessory");
        const isAccessoryAdd = flattened.slotKey === "accessory" || flattened.is_accessory;

        if (!hasSlotAssignment && !isAccessoryAdd) {
            const exists = selectedProducts.some((p) => p.product_id === flattened.product_id);
            if (exists) {
                showError?.("Product already added");
                return;
            }
        }

        let next: FlattenedProduct[];
        if (hasSlotAssignment) {
            next = selectedProducts.filter(
                (p) => !isProductInSlot(p, flattened.slotKey!, flattened.slot_id)
            );
            next = [...next, { ...flattened, location: flattened.location || [] }];
        } else {
            next = [...selectedProducts, { ...flattened, location: flattened.location || [] }];
        }

        updateProducts(next);
        setPickerOpen(false);
    };

    const removeRow = (prodId: string) => {
        const item = selectedProducts.find((p) => p.product_id === prodId);
        if (item?.slotKey) {
            postTypeConfigRef.current?.clearSlot(item.slotKey);
        } else {
            postTypeConfigRef.current?.clearSlotByProductId(prodId);
        }
        const next = selectedProducts.filter((p) => p.product_id !== prodId);
        updateProducts(next);
    };

    const navigate = useNavigate();
    const safeNavigate = createSafeNavigate(navigate);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: apiKey,
        libraries,
    });

    const [selectedLocation, setSelectedLocation] = useState<{
        lat: number;
        lng: number;
    } | null>(null);

    const [selectedAgent, setSelectedAgent] = useState<Selected | null>(null);
    const invoiceRef = useRef<HTMLDivElement>(null);
    const triggerRecomputeWithRef = React.useRef<(override?: { fees?: any[]; discountCode?: string; action?: OrderResolveAction; installationCost?: number; destination?: string }) => void>(() => {});

    const normalizeInstallationToSalesOrder = (inst: any) => {
        if (!inst) return null;
        const billing = inst?.billing_address || null;
        const shipping = inst?.installation_details?.installation_address || null;
        const items = Array.isArray(inst?.line_items)
            ? inst.line_items.map((li: any) => ({
                product_name: li.product_name,
                sku: li.sku,
                quantity: li.quantity,
                unit_retail_price: li.unit_price,
                total_price: li.total_price,
                customizations: li.customizations || null,
            }))
            : [];
        return {
            order_number: inst?.order_number,
            order_status: inst?.status,
            payment_status: inst?.payment_status,
            customer_first_name: inst?.user_name || "",
            customer_last_name: "",
            customer_email: inst?.user_email,
            customer_phone: inst?.user_phone,
            created_at: inst?.created_at,
            billing_address: billing,
            shipping_address: shipping,
            items,
            payment_method: inst?.payment_method || "",
            total_amount: inst?.total_amount ?? inst?.installation_cost ?? 0,
            shipping_amount: 0,
            tax_amount: inst?.tax_amount ?? 0,
            discount_amount: inst?.discount_amount ?? 0,
        } as any;
    };

    const handleDownloadInvoice = async () => {
        if (!invoiceRef.current) return;
        const canvas = await html2canvas(invoiceRef.current);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        pdf.save(`${installationOrder?.order_number || "installation"}.pdf`);
    };

    const [selectedBillingAddress, setSelectedBillingAddress] = useState<Addresses | null>(null);

    const [installationAddress, setInstallationAddress] = useState<Addresses>();
    const [zeroOrNegativeMsg, setZeroOrNegativeMsg] = React.useState<string>("");
    const [dynamicCostId, setDynamicCostId] = React.useState<string>("");
    const [dynamicTaxable, setDynamicTaxable] = React.useState<boolean>(false);
    const [showTaxDetails, setShowTaxDetails] = useState(false);

    const [selectedInstaller, setSelectedInstaller] = useState<{
        value: string;
        label: string;
        membershipId?: string;
        globalUserId?: string;
        organizationId?: string;
    } | null>(null);

    const installerOptions = useMemo(() => {
        const fromSuppliers =
            suppliers?.map((supplier) => ({
                value: supplier.supplier_id,
                label: supplier.name,
                organizationId: supplier.supplier_id,
            })) ?? [];
        const vendor = resolveInstallationVendorSelectOption(installationOrder);
        if (vendor && !fromSuppliers.some((opt) => opt.value === vendor.value)) {
            return [...fromSuppliers, vendor];
        }
        return fromSuppliers;
    }, [suppliers, installationOrder]);

    const productOptions = productObjs?.map((item) => ({
        value: item.product_id,
        label: item.product.name,
    }));
    const priorityOptions = [
        { value: 1, label: "High" },
        { value: 2, label: "Medium" },
        { value: 3, label: "Low" },
    ];

    // Figure out picker props from current UI selection
    const pickerUserType: "agent" | "office" | null =
        selectedAgent?.value
            ? "agent"
            : "agent";
    const pickerUserId: string =
        installationOrder?.agent_id ||
        "";
    const pickerSignageCompanyId: string = String(
        installationOrder?.seller_org_id ||
            resolveInstallationSellerOrganizationId(
                selectedInstaller?.value,
                installationOrder
            ) ||
            ""
    ).trim();

    const pickerEndUserId: string | undefined =
        selectedAgent?.value || installationOrder?.agent_id || undefined;

    const postTypeOrderContext = useMemo((): import("pages/signage/PostTypeSignConfiguration").PostTypeOrderEndUserContext | null => {
        if (selectedAgent?.value) {
            const agent = selectedAgent as {
                membershipId?: string;
                membership_id?: string;
                license_type?: string;
                globalUserId?: string;
                global_user_id?: string;
                organizationId?: string;
                organization_id?: string;
            };
            return {
                membershipId: String(agent.membershipId ?? agent.membership_id ?? selectedAgent.value).trim(),
                licenseType: String(agent.license_type || "AGENT").trim(),
                globalUserId: String(agent.globalUserId ?? agent.global_user_id ?? "").trim() || undefined,
                organizationId: String(agent.organizationId ?? agent.organization_id ?? "").trim() || undefined,
            };
        }
        const orderMembershipId = String(
            (installationOrder as { agent_membership_id?: string } | null)?.agent_membership_id ||
                installationOrder?.agent_id ||
                ""
        ).trim();
        if (orderMembershipId) {
            return {
                membershipId: orderMembershipId,
                licenseType: "AGENT",
            };
        }
        return null;
    }, [selectedAgent, installationOrder]);

    const handleSlotProductSelect = (product: LinkedProduct, slotKey: string, slotId?: string) => {
        const isLinked = product.linked_mode !== "catalog" && (product.inventory_source === "agent" || product.inventory_source === "office");
        const isNewCatalog = product.linked_mode === "catalog";
        const inventoryTypeForNew =
            isNewCatalog && pickerUserType
                ? pickerUserType === "agent"
                    ? "agent"
                    : "office"
                : product.inventory_source || "";
        const hasDesign = isMeaningfulObjectId(product.design_id);
        const previewId = String(product.preview_url ?? "").trim();
        const imageForRow =
            hasDesign && previewId ? previewId : product.images?.[0]?.url || "";
        const lineImages = imageForRow
            ? [{ url: imageForRow }]
            : normalizeInstallationLineItemImages(product.images);
        const flattened: FlattenedProduct = {
            product_id: product.product_id,
            name: product.name,
            sku: product.sku,
            inventory_type: inventoryTypeForNew,
            current_status: isNewCatalog ? "with_supplier" : product.current_status,
            availableqty: product.available_quantity ?? 0,
            quantity: 1,
            images: lineImages,
            image_url: imageForRow,
            location: product.location,
            is_accessory: slotKey === "accessory",
            ...(slotKey !== "accessory" ? { slotKey, slot_id: slotId ?? "" } : { slot_id: "" }),
            ...(isLinked && pickerUserId ? { user_id: pickerUserId } : {}),
            ...(product.variant_id ? { variant_id: String(product.variant_id).trim() } : {}),
            ...(isNewCatalog
                ? {
                    is_new_catalog: true,
                    is_new_purchase: true,
                    source_product_id: product.product_id,
                    variant_id: product.variant_id,
                    unit_price: product.retail_price != null ? Number(product.retail_price) : undefined,
                    is_taxable: Boolean((product as any).is_taxable ?? (product as any).taxable ?? (product as any)["product.is_taxable"]),
                    ...(product.customizations ? { customizations: product.customizations } : {}),
                }
                : {}),
            ...(hasDesign
                ? {
                    design_id: String(product.design_id ?? "").trim(),
                    design_name: String(product.design_name ?? "").trim(),
                    preview_url: previewId,
                }
                : {}),
        };
        void handleAddFromPicker(flattened);
    };

    const handleCustomItemAdd = async (data: {
        item_name: string;
        custom_info: string;
        price: string;
        quantity: string;
        taxable: boolean;
        length: string;
        height: string;
        width: string;
        weight: string;
    }) => {
        const t = token || "";
        if (!t) {
            showError("Session expired. Please log in again.");
            return;
        }
        try {
            const productId = await fetchNewUniqueId(t);
            const variantId = await fetchNewUniqueId(t);
            const qty = Math.max(1, parseInt(String(data.quantity), 10) || 1);
            const price = parseFloat(String(data.price)) || 0;
            const customProduct: FlattenedProduct = {
                product_id: productId,
                variant_id: variantId,
                name: String(data.item_name || "").trim() || "Custom Item",
                sku: `custom_sku_${productId}`,
                inventory_type: "custom",
                current_status: "with_supplier",
                availableqty: 0,
                quantity: qty,
                is_new_purchase: true,
                source_product_id: productId,
                unit_price: price,
                unit_retail_price: price,
                changed_unit_price: price,
                is_taxable: !!data.taxable,
                custom_information: String(data.custom_info || "").trim(),
            };
            updateProducts([...selectedProducts, customProduct]);
        } catch (err) {
            showError(err instanceof Error ? err.message : "Failed to add custom item");
            throw err;
        }
    };

    useEffect(() => {
        setUserInfo(sessionLicenseFromAuthCookies());
        setLoading(false);
    }, []);
    // Extract fetchOrderDetails as a separate function so it can be called from other functions
    const fetchOrderDetails = useCallback(async () => {
        try {
            const raw = await fetchInstallationOrderById(token, installationId!);
            const data = normalizeInstallationOrderFetchPayload(raw);
            setInstallationOrder(data);

            // Sync totals from API (installation, special fee, product tax from line_items)
            if (data) {
                formik.setFieldValue("totals.installation_tax_amount", Number(data.installation_tax_amount || 0), false);
                const feeTaxTotal = Array.isArray(data?.specialfee)
                    ? data.specialfee.reduce((sum: number, fee: any) => sum + Number(fee.specialfee_tax_amount || 0), 0)
                    : 0;
                formik.setFieldValue("totals.specialfee_tax_amount", feeTaxTotal, false);
                const productTaxTotal = Array.isArray(data?.line_items)
                    ? data.line_items.reduce(
                          (sum: number, li: any) =>
                              sum + Number((li?.item_tax_info as any)?.total_product_tax_amount ?? li?.tax_amount ?? 0),
                          0
                      )
                    : 0;
                formik.setFieldValue("totals.product_tax_amount", productTaxTotal, false);

                const mappedResolvedLines = mapInstallationOrderLinesToResolved(data?.line_items);
                if (mappedResolvedLines.length > 0) {
                    formik.setFieldValue("resolved_line_items", mappedResolvedLines, false);
                    lastResolvedInstallationRef.current = {
                        ...(lastResolvedInstallationRef.current || {}),
                        line_items: mappedResolvedLines,
                        installation_cost: Number(data?.installation_cost ?? 0),
                        subtotal_amount: Number(data?.subtotal_amount ?? 0),
                        total_amount: Number(data?.total_amount ?? 0),
                        discount_code: getInstallationResolveRootDiscountCode({
                            orderDiscountCode: data?.discount_code,
                            orderCouponCode: (data as any)?.coupon_code,
                            orderLineItems: data?.line_items,
                        }),
                        discount_amount: Number(data?.discount_amount ?? 0),
                    };
                }
            }
        } catch (err: any) {
            safeConsole.error("Order Detail Fetch Error:", err.message);
            await handleApiError(err, {
                module: "installation",
                action: "Agent_View_Installation_fetch_order_details",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}`,
                method: "GET",
            }, token);
        }
    }, [installationId, token]);

    useEffect(() => {
        fetchOrderDetails();
    }, [installationId, token]);

    useEffect(() => {
        let cancelled = false;
        const projectId = String(
            installationOrder?.project_id ||
            installationOrder?.project?.id ||
            ""
        ).trim();
        if (!token || !projectId) {
            setHasApprovedMessage(false);
            setApprovedMessageData(null);
            return;
        }
        (async () => {
            try {
                const approved = await fetchProjectApprovedMessage(token, projectId);
                if (cancelled) return;
                const hasMessage = Boolean(approved?.has_approved_message);
                setHasApprovedMessage(hasMessage);
                setApprovedMessageData(hasMessage ? approved?.data ?? null : null);
            } catch {
                if (cancelled) return;
                setHasApprovedMessage(false);
                setApprovedMessageData(null);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [installationOrder, token]);

    // âœ… Initialize installation cost and tax metadata from backend data
    useEffect(() => {
        if (!installationOrder) return;

        // âœ… Initialize installation cost from backend
        if (installationOrder.installation_cost !== undefined && installationCost === null) {
            // console.log("ðŸ’° Initializing installation cost from backend:", installationOrder.installation_cost);
            setInstallationCost(Number(installationOrder.installation_cost));
        }

        // âœ… Initialize dynamic cost metadata
        if (installationOrder?.dynamic_cost_id && !dynamicCostId) {
            // console.log("ðŸ”‘ Initializing dynamic_cost_id from backend:", installationOrder.dynamic_cost_id);
            setDynamicCostId(installationOrder.dynamic_cost_id);
        }

        // âœ… Initialize taxable flag
        if (installationOrder?.installation_taxable !== undefined && !dynamicTaxable) {
            setDynamicTaxable(installationOrder.installation_taxable);
        }
    }, [installationOrder]);

    // Populate uploadedFileMeta from installationOrder.proof_of_installation
    useEffect(() => {
        if (installationOrder?.proof_of_installation && Array.isArray(installationOrder.proof_of_installation)) {
            const proofFiles: ProofFile[] = installationOrder.proof_of_installation.map((file: any) => ({
                file_name: file.file_name || "",
                file_url: file.file_url || "",
                content_type: file.content_type || "",
                uploaded_date: file.uploaded_date || new Date().toISOString()
            }));
            setUploadedFileMeta(proofFiles);
        }
    }, [installationOrder]);

    /** Files shown in `Instructions` (snake_case or camelCase on the order). */
    const instructionUploadedFiles = useMemo(
        () => getInstructionUploadedFilesFromOrder(installationOrder),
        [installationOrder]
    );

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            const files = instructionUploadedFiles;
            const fileIds = files
                .map((f: any) => String(f?.file_id || "").trim())
                .filter((id: string) => /^[0-9a-f]{24}$/i.test(id));
            if (!token || fileIds.length === 0) {
                if (!cancelled) setInstructionFileUrlMap({});
                return;
            }
            try {
                const map = await batchPresignUrls(fileIds, token);
                if (!cancelled) setInstructionFileUrlMap(map || {});
            } catch {
                if (!cancelled) setInstructionFileUrlMap({});
            }
        };
        run();
        return () => {
            cancelled = true;
        };
    }, [instructionUploadedFiles, token]);

    const instructionAttachments = useMemo(() => {
        const files = instructionUploadedFiles;
        return files.map((f: any, index: number) => {
            const fileId = String(f?.file_id || "").trim();
            const href = (fileId && instructionFileUrlMap[fileId]) || String(f?.file_url || "").trim();
            return {
                id: fileId || `uploaded-${index}`,
                name: String(f?.file_name || "Attachment"),
                href,
                previewUrl: href,
                dateLabel: f?.uploaded_date ? new Date(f.uploaded_date).toLocaleDateString() : undefined,
            };
        });
    }, [instructionUploadedFiles, instructionFileUrlMap]);

    useEffect(() => {
        const fetchSuppliersByUserId = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/agent/suppliers/${userId}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch supplier list");
                }

                const data = await response.json();
                // console.log("Suppliers:", data);
                setSuppliers(data);
            } catch (err) {
                setError(
                    err instanceof Error ? err.message : "An unknown error occurred"
                );
                await handleApiError(err, {
                    module: "installation",
                    action: "Agent_View_Installation_fetch_suppliers_by_user_id",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/agent/suppliers/${userId}`,
                    method: "GET",
                }, token);
            } finally {
                setLoading(false);
            }
        };

        fetchSuppliersByUserId();
    }, [token, userId])

    useEffect(() => {
        return () => {
            if (preview) URL.revokeObjectURL(preview);
        };
    }, [preview]);

    useEffect(() => {
        const fetchAddresses = async () => {
            const routeMembershipId =
                resolveInstallationAddressMembershipId(installationOrder) || userId || "";
            if (!routeMembershipId || !token) return;
            try {
                const data = await fetchUserAddresses(token, routeMembershipId);
                const rows = Array.isArray(data) ? data : [];
                setAddressObjects(
                    mergeInstallationOrderBillingAddress(rows, installationOrder?.billing_address)
                );
            } catch (err) {
                setError(
                    err instanceof Error ? err.message : "An unknown error occurred"
                );
                await handleApiError(err, {
                    module: "installation",
                    action: "Agent_View_Installation_fetch_addresses",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/organization-memberships/${routeMembershipId}/addresses`,
                    method: "GET",
                }, token);
            } finally {
                setLoading(false);
            }
        };

        if (installationOrder || userId) {
            void fetchAddresses();
        }
    }, [token, installationOrder, userId]);

    const addressOptions =
        addressObjects !== null
            ? addressObjects?.map((address) => ({
                ...address,
                value: address._id,
                label: `${address.label}: ${address.address_details.addressLine1}, ${address.address_details.city}, ${address.address_details.state}, ${address.address_details.zip ? address.address_details.zip : ''}`,
            }))
            : [];

    const fetchLinkedProducts = async (
        signageCompanyId: string
    ) => {
        // console.log("fetchLinkedProducts IN");
        if (!userId || !signageCompanyId) return;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/inventory/agent/${userId}/signage/${signageCompanyId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
            setProductObjs(data);

            if (!response.ok) {
                showError(data?.error || "Failed to fetch linked products");
            } else {
                // setLinkedProducts(data); if needed
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : "Unknown error occurred");
            await handleApiError(err, {
                module: "installation",
                action: "Agent_View_Installation_fetch_linked_products",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: `${process.env.REACT_APP_API_URL}/inventory/agent/${userId}/signage/${signageCompanyId}`,
                method: "GET",
            }, token);
        }
    };

    // Fetch individual product by ID based on inventory_type
    const fetchProductById = async (
        inventoryType: "agent" | "office",
        userId: string,
        productId: string
    ): Promise<ProductObj | null> => {
        const url = `${process.env.REACT_APP_API_URL}/${inventoryType}/${userId}/inventory/${productId}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                // safeConsole.error(`Failed to fetch product ${productId}:`, errorData?.error || response.statusText);
                return null;
            }

            const data: ProductObj = await response.json();
            return data;
        } catch (err) {
            // safeConsole.error(`Error fetching product ${productId}:`, err);
            await handleApiError(err, {
                module: "installation",
                action: "Agent_View_Installation_fetch_product_by_id",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: url,
                method: "GET",
                additionalInfo: { productId, inventoryType },
            }, token);
            return null;
        }
    };

    // based on instaletion Address we are calling the dyniamc cost
    useEffect(() => {
        if (!installationAddress && !selectedInstaller?.value) return;

        const currentLat = installationAddress?.address_details?.latitude;
        const currentLng = installationAddress?.address_details?.longitude;

        if (
            !currentLat ||
            !currentLng ||
            currentLat === 0 ||
            currentLng === 0
        ) {
            return;
        }

        // Get original address from installation order
        const originalAddress = installationOrder?.installation_details?.installation_address;
        const originalLat = originalAddress?.address_details?.latitude;
        const originalLng = originalAddress?.address_details?.longitude;

        // Check if address is different from original (checking lat/lng)
        const isAddressChanged =
            originalLat !== currentLat ||
            originalLng !== currentLng;

        const fetchInstallationCost = async () => {
            const costPayload = {
                installation_address: {
                    addressLine1: installationAddress?.address_details?.addressLine1,
                    addressLine2: installationAddress?.address_details?.addressLine2,
                    city: installationAddress?.address_details?.city,
                    state: installationAddress?.address_details?.state,
                    country: installationAddress?.address_details?.country,
                    zip: installationAddress?.address_details?.zip,
                    cityCode: installationAddress?.address_details?.cityCode,
                    stateCode: installationAddress?.address_details?.stateCode,
                    countryCode: installationAddress?.address_details?.countryCode,
                    latitude: currentLat,
                    longitude: currentLng,
                }
            };

            try {
                const sellerOrgId = resolveInstallationSellerOrganizationId(
                    installationOrder?.seller_org_id ?? selectedInstaller?.value,
                    installationOrder
                );
                const data = await postInstallationDynamicCost(token, sellerOrgId, costPayload);

                // Only set installation cost if address is different from original
                setDynamicCostId(data.id);
                setDynamicTaxable(data.is_taxable || data.taxable);
                if (isAddressChanged) {
                    setInstallationCost(data.cost || 0);
                }
                triggerRecomputeWithRef.current?.();
            } catch (error: any) {
                safeConsole.error("Cost fetch error:", error.message);
                const sellerOrgId = resolveInstallationSellerOrganizationId(
                    installationOrder?.seller_org_id ?? selectedInstaller?.value,
                    installationOrder
                );
                await handleApiError(error, {
                    module: "installation",
                    action: "Agent_View_Installation_fetch_installation_cost",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}${installationOrderUrls.dynamicCost(sellerOrgId)}`,
                    method: "POST",
                    requestBody: costPayload,
                }, token);
                // setInstallationCost(null);
            }
        };

        fetchInstallationCost();
    }, [installationAddress, installationOrder, selectedInstaller, token]);


    const baseSchema = Yup.object({
        userEmail: Yup.string()
            .email("Invalid email")
            .required("Email is required"),
        userPhone: phoneValidation,
        installer: Yup.string().required("Installer is required"),
        scheduled_date: Yup.string().required("scheduled_date date is required"),
        billingAddressId: Yup.string().required("Billing address is required"),

        installationAddressId: Yup.string().when("isSameAsBilling", {
            is: false,   // âœ… explicitly check false
            then: (schema) => schema.required("Installation address is required"),
            otherwise: (schema) => schema.notRequired()
        }),
        isSameAsBilling: Yup.boolean(),
    });

    const validationSchema = isEdit ? baseSchema : Yup.object({});

    const initialResolvedLineItems = React.useMemo(
        () => mapInstallationOrderLinesToResolved(installationOrder?.line_items),
        [installationOrder?.line_items]
    );

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema,
        initialValues: {
            userType: installationOrder?.user_type,
            userFirstName: userInfo?.firstName || "",
            userLastName: userInfo?.lastName || "",
            userEmail: installationOrder?.user_email,
            userPhone: installationOrder?.user_phone,
            brokerageFirmsId: installationOrder?.brokerage_firm_id,
            teamMemberId: installationOrder?.team_member_id,
            company: "",
            installer: resolveInstallationSellerOrganizationId(
                installationOrder?.seller_org_id,
                installationOrder
            ),
            office: installationOrder?.office,
            agent: installationOrder?.agent_id,
            scheduled_date: installationOrder?.installation_details?.scheduled_date?.split("T")[0] || "",
            jobs_today: 0,
            installeId:
              installationOrder?.installation_details?.installer_membership_id ||
              installationOrder?.installation_details?.assignee_membership_id ||
              installationOrder?.installation_details?.installer_id ||
              "",
            priority: installationOrder?.priority,
            billing_address: installationOrder?.billing_address,
            installation_address: installationOrder?.installation_details.installation_address,
            isSameAsBilling: !!installationOrder?.both_address_same,
            billingAddressId: installationOrder?.billing_address?._id,
            installationAddressId: formatInstallationAddressForDisplay(
                installationOrder?.installation_details?.installation_address
            ),
            location: "",
            products: "",
            instructions: "",
            payment_method: "",
            image: null,
            installation_charge: installationOrder?.installation_cost,
            discount: installationOrder?.discount_amount || 0,
            subtotal: installationOrder?.subtotal_amount || installationOrder?.total_amount || 0,
            total: installationOrder?.total_amount,
            tax: 0,
            localLawsChecked: installationOrder?.local_laws_checked || false,
            enable_partial_payment: false,
            partial_amount: 0,
            transactionId: "",
            paymentMethod: "",
            gatecode: installationOrder?.gate_access_code,
            gateCodeEnabled: false,
            discount_amount: installationOrder?.discount_amount,
            discount_code:
                getInstallationResolveRootDiscountCode({
                    orderDiscountCode: installationOrder?.discount_code,
                    orderCouponCode: (installationOrder as any)?.coupon_code,
                    orderLineItems: installationOrder?.line_items,
                }) || installationOrder?.discount_code,
            product_discount_amount: (installationOrder as any)?.product_discount_amount ?? 0,
            discount_applies_to: (installationOrder as any)?.discount_applies_to ?? "",
            installation_cost: installationOrder?.installation_cost,
            install_taxable: installationOrder?.installation_taxable,
            install_tax_percentage: installationOrder?.installation_tax_percentage || "",
            totals: {
                installation_subtotal: installationOrder?.subtotal_amount || installationOrder?.installation_cost || 0,
                installation_tax_amount: installationOrder?.installation_tax_amount || 0,
                specialfee_subtotal: Array.isArray(installationOrder?.specialfee)
                    ? installationOrder.specialfee.reduce((sum: number, fee: any) => sum + Number(fee.specialfee_amount || 0), 0)
                    : 0,
                specialfee_tax_amount: Array.isArray(installationOrder?.specialfee)
                    ? installationOrder.specialfee.reduce((sum: number, fee: any) => sum + Number(fee.specialfee_tax_amount || 0), 0)
                    : 0,
                product_subtotal: (installationOrder as any)?.product_subtotal ?? 0,
                product_tax_amount: Array.isArray(installationOrder?.line_items)
                    ? installationOrder.line_items.reduce(
                          (sum: number, li: any) =>
                              sum + Number((li?.item_tax_info as any)?.total_product_tax_amount ?? li?.tax_amount ?? 0),
                          0
                      )
                    : 0,
                grand_total: installationOrder?.total_amount || installationOrder?.grand_total || 0,
                cartId: installationOrder?.cart_id,
            },
            specialFees: [] as Array<{
                id: string;
                name: string;
                amount: number;
                taxable?: boolean;
                tax_percentage?: number | null;
            }>,
            calc_fee_rate_str: installationOrder?.calc_fee_rate_str || 0,
            calc_overall_rate_str: installationOrder?.over_all__tax_amount || 0,
            calc_install_rate_str: installationOrder?.installation_tax_amount || 0,
            resolved_line_items: initialResolvedLineItems,
        },
        onSubmit: async (values) => {
            if (!isEdit) return;

            // âœ… Validate required special fees BEFORE submission
            const requiredFees = allAvailableSpecialFees.filter((f: any) => f.required === true);
            console.log("Required Fees:", requiredFees);
            const selectedFeeIds = (formik.values.specialFees || []).map((f: any) => String(f.id));
            console.log("Selected Fee IDs:", selectedFeeIds);
            const missingRequiredFees = requiredFees.filter((f: any) => !selectedFeeIds.includes(String(f.id || f._id)));
            console.log("Missing Required Fees:", missingRequiredFees);

            if (missingRequiredFees.length > 0) {
                const feeNames = missingRequiredFees.map((f: any) => f.name).join(", ");
                showError(`The following required special fees must be selected: ${feeNames}`);
                return; // Don't submit
            }

            setFormSubmitting(true);
            let updateOrderPayload: any;
            try {
                const imageUrl = values.image ? await uploadFile(values.image) : null;
                let lineItems: any[] = [];

                // ðŸ“¦ 1. Regular products (agent or office)
                // Fetch individual products based on inventory_type and user_id from selectedProducts
                const fetchedProductObjs: ProductObj[] = [];
                for (const product of selectedProducts) {
                    if (product.inventory_type && product.product_id) {
                        // Get user_id from product or fallback to installationOrder
                        const userIdForProduct = product.user_id ||
                            (product.inventory_type === "office"
                                ? installationOrder?.team_member_id
                                : installationOrder?.agent_id) ||
                            userId || "";

                        if (userIdForProduct) {
                            const productData = await fetchProductById(
                                product.inventory_type as "agent" | "office",
                                userIdForProduct,
                                product.product_id
                            );
                            if (productData) {
                                fetchedProductObjs.push(productData);
                            } else {
                                showError(`Failed to fetch details for product: ${product.name || product.product_id}`);
                                setFormSubmitting(false);
                                return;
                            }
                        } else {
                            showError(`Missing user ID for product: ${product.name || product.product_id}`);
                            setFormSubmitting(false);
                            return;
                        }
                    }
                }

                const round2 = (n: number) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
                const resolvedLineItemsSource =
                    lastResolvedInstallationRef.current?.line_items?.length
                        ? lastResolvedInstallationRef.current.line_items
                        : mapInstallationOrderLinesToResolved(installationOrder?.line_items);
                const resolvedLineMap = new Map(
                    resolvedLineItemsSource.map((li) => [orderLineKey(li.product_id, li.variant_id), li])
                );
                const resolvedOrderForScope = lastResolvedInstallationRef.current;
                const submitDiscountScope = resolvedOrderForScope
                    ? inferInstallationDiscountScopeFromResolved(resolvedOrderForScope)
                    : inferInstallationDiscountScope({
                          discountAppliesTo: formik.values.discount_applies_to,
                          discountCode: formik.values.discount_code,
                          discountAmount: formik.values.discount_amount,
                          productDiscountAmount: formik.values.product_discount_amount,
                          lineItems: resolvedLineItemsSource,
                      });
                const submitDiscountCode = String(
                    formik.values.discount_code || resolvedOrderForScope?.discount_code || ""
                ).trim();
                const { rootDiscountCode, lineDiscountCode } = splitInstallationDiscountForPayload(
                    submitDiscountCode,
                    submitDiscountScope
                );

                const productDiscountAmount =
                    submitDiscountScope === "product"
                        ? Number(
                              formik.values.product_discount_amount ??
                                  formik.values.discount_amount ??
                                  0
                          )
                        : 0;
                let productTotalForSubmit = 0;
                for (const p of selectedProducts || []) {
                    const oli = installationOrder?.line_items?.find((item: any) => {
                        if (String(item?.product_id) !== String(p.product_id)) return false;
                        return p.inventory_type === "rotational"
                            ? item.inventory_source === "rotational"
                            : item.inventory_source !== "rotational";
                    });
                    const unitPrice = Number(oli?.unit_price ?? p?.retail_price ?? 0);
                    productTotalForSubmit += unitPrice * Number(p.quantity || 0);
                }
                const discountToAllocateSubmit = productTotalForSubmit > 0 ? Math.min(productDiscountAmount, productTotalForSubmit) : 0;

                lineItems = selectedProducts.map((product) => {
                    const matched = fetchedProductObjs.find((p) => p.product_id === product.product_id);
                    const variant: any = matched?.product?.variants?.[0] || {};
                    const originalLineFromOrder = installationOrder?.line_items?.find((item: any) => {
                        if (String(item?.product_id ?? "") !== String(product.product_id)) return false;
                        return product.inventory_type === "rotational"
                            ? item.inventory_source === "rotational"
                            : item.inventory_source !== "rotational";
                    });
                    const originalItem = originalLineFromOrder;
                    const originalQty = Number(originalItem?.quantity || 0);
                    const currentQty = Number(product.quantity || 0);
                    const quantityUnchanged = originalQty === currentQty;

                    const isNewPurchaseLine =
                        originalLineFromOrder != null
                            ? Boolean(originalLineFromOrder.is_new_purchase)
                            : Boolean(product.is_new_purchase ?? true);
                    const resolvedVariantId = String(
                        originalLineFromOrder?.variant_id ?? product.variant_id ?? variant?.variant_id ?? ""
                    );
                    const resolvedLine = resolvedLineMap.get(
                        orderLineKey(String(product.product_id), resolvedVariantId)
                    );
                    const rowDiscTotal = round2(Number(resolvedLine?.discount_on_total_quantity ?? 0));
                    const perUnitDiscount = Number(product.quantity) > 0
                        ? round2(rowDiscTotal / Number(product.quantity))
                        : 0;
                    const lineTax = round2(
                        Number(
                            resolvedLine?.item_tax_info?.total_product_tax_amount ??
                                originalLineFromOrder?.item_tax_info?.total_product_tax_amount ??
                                originalLineFromOrder?.tax_amount ??
                                0
                        )
                    );

                    const quantity = Number(product.quantity) || 0;
                    let unitPrice = Number(originalItem?.unit_price ?? product?.retail_price ?? 0);
                    let totalPrice = unitPrice * quantity;

                    if (isNewPurchaseLine) {
                        const payloadUnitRetail = round2(
                            Number(
                                resolvedLine?.unit_retail_price ??
                                    originalLineFromOrder?.unit_retail_price ??
                                    product?.unit_retail_price ??
                                    originalLineFromOrder?.unit_price ??
                                    product?.retail_price ??
                                    product?.unit_price ??
                                    0
                            )
                        );
                        const changedUnitPrice = round2(
                            Number(
                                resolvedLine?.changed_unit_price ??
                                    originalLineFromOrder?.changed_unit_price ??
                                    product?.changed_unit_price ??
                                    payloadUnitRetail ??
                                    0
                            )
                        );
                        unitPrice = payloadUnitRetail;
                        totalPrice = round2(changedUnitPrice * quantity + lineTax - rowDiscTotal);
                    } else if (productDiscountAmount > 0 && productTotalForSubmit > 0 && quantity > 0) {
                        const discountShare = (totalPrice / productTotalForSubmit) * discountToAllocateSubmit;
                        totalPrice = Math.max(0, totalPrice - discountShare);
                        unitPrice = Math.round((totalPrice / quantity) * 100) / 100;
                    }

                    const designId = isMeaningfulObjectId(product.design_id)
                        ? String(product.design_id).trim()
                        : isMeaningfulObjectId(originalLineFromOrder?.design_id)
                            ? String(originalLineFromOrder!.design_id).trim()
                            : "";
                    const previewUrl = String(
                        product.preview_url ?? originalLineFromOrder?.preview_url ?? ""
                    ).trim();
                    const lineItemImages = buildInstallationLineItemImages({
                        product,
                        originalLine: originalLineFromOrder,
                        variantCatalogImages: variant?.images,
                    });

                    const studioLinePayload =
                        designId && previewUrl
                            ? {
                                design_id: designId,
                                design_name: String(
                                    originalLineFromOrder?.design_name ?? product.design_name ?? ""
                                ).trim(),
                                preview_url: previewUrl,
                            }
                            : {};
                    const changedUnitPriceForPayload = round2(
                        Number(
                            resolvedLine?.changed_unit_price ??
                                originalLineFromOrder?.changed_unit_price ??
                                product?.changed_unit_price ??
                                unitPrice ??
                                0
                        )
                    );

                    return {
                        product_id: product.product_id,
                        variant_id: product.variant_id || variant?.variant_id,
                        slot_id: product.is_accessory
                            ? ""
                            : String(product.slot_id ?? originalLineFromOrder?.slot_id ?? "").trim(),
                        source_product_id:
                            originalLineFromOrder?.source_product_id ?? product.source_product_id ?? null,
                        is_new_purchase:
                            originalLineFromOrder != null
                                ? Boolean(originalLineFromOrder.is_new_purchase)
                                : Boolean(product.is_new_purchase ?? true),
                        inventory_source:
                            originalLineFromOrder?.inventory_source ?? product?.inventory_type ?? "",
                        is_accessories: Boolean(
                            originalLineFromOrder?.is_accessories ??
                                originalLineFromOrder?.is_accessory ??
                                product.is_accessory
                        ),
                        is_production:
                            originalLineFromOrder?.is_production ?? product.is_production ?? false,
                        product_name: product?.name || "",
                        sku: product?.sku || "",
                        quantity,
                        unit_price: unitPrice,
                        total_price: totalPrice,
                        discount_on_unit_quantity: perUnitDiscount,
                        discount_on_total_quantity: rowDiscTotal,
                        discount_code:
                            submitDiscountScope === "product" && isNewPurchaseLine
                                ? String(resolvedLine?.discount_code ?? lineDiscountCode ?? "").trim()
                                : "",
                        ...(isNewPurchaseLine
                            ? {
                                  changed_unit_price: changedUnitPriceForPayload,
                                  item_sub_total: round2(changedUnitPriceForPayload * quantity),
                              }
                            : {}),
                        tax_amount: isNewPurchaseLine ? lineTax : 0,
                        inventory_deducted: false,
                        fulfillment_type: "stock",
                        production_status: product.productionStatus || "not started",
                        is_rotational: product?.is_rotational || false,
                        current_status: product?.current_status || product?.product_current_status || product?.product_location_status || "",
                        notes: product.notes || "",
                        images: lineItemImages,
                        ...studioLinePayload,
                        ...(product.inventory_type !== "rotational" && originalLineFromOrder?.customizations
                            ? { customizations: originalLineFromOrder.customizations }
                            : {}),
                        storage_locations:
                            product.storage_locations && product.storage_locations.length > 0
                                ? product.storage_locations.map((loc: any) => ({
                                    ...loc,
                                    quantity: quantityUnchanged ? loc.quantity : Number(product.quantity)
                                }))
                                : [
                                    {
                                        quantity: Number(product.quantity),
                                        product_location_status: matched?.linked_installer_details?.storage_locations?.[0]?.product_location_status || "",
                                        current_status: matched?.linked_installer_details?.storage_locations?.[0]?.product_location_status || "",
                                        assigned_at: new Date().toISOString(),
                                        location: matched?.linked_installer_details?.storage_locations?.[0]?.location || {},
                                    }
                                ],
                    };
                });

                // ðŸ”„ 2. Rotational allocations
                // Object.entries(allocatedUnits).forEach(([linkedProductId, units]) => {
                //     if (units.length === 0) return;
                //     lineItems.push({
                //         product_id: units[0].rotationalProductId,
                //         inventory_source: "rotational",
                //         warehouse_id: units[0].warehouseId || "",
                //         serial_ids: units.map((u) => u.serial_id),
                //         product_name: "",
                //         sku: "",
                //         quantity: 1,
                //         unit_price: 0,
                //         total_price: 0,
                //         discount: 0,
                //         tax_amount: 0,
                //         inventory_deducted: false,
                //         fulfillment_type: "stock",
                //         production_status: null,
                //         is_rotational: true,
                //         current_status: "",
                //         notes: "",
                //     });
                // });
                // Example file upload handling
                const t = formik.values.totals || {};
                const installSub = Number(t.installation_subtotal || 0);
                const feeSub = Number(t.specialfee_subtotal || 0);
                const installTax = Number(t.installation_tax_amount || 0);
                const feeTax = Number(t.specialfee_tax_amount || 0);
                const productSub = Number((t as any).product_subtotal || 0);
                const productTax = Number((t as any).product_tax_amount || 0);

                // Allocate product tax to each line item (proportional by total_price)
                const lineItemsWithTax = lineItems.map((li: any) => {
                    const totalPrice = Number(li.total_price || 0);
                    const taxAmount = productSub > 0 && totalPrice > 0
                        ? round2((totalPrice / productSub) * productTax)
                        : Number((installationOrder?.line_items?.find((o: any) => o.product_id === li.product_id) as any)?.tax_amount ?? 0);
                    return { ...li, tax_amount: taxAmount };
                });
                const lineItemsMerged =
                    submitDiscountScope === "installation"
                        ? lineItemsWithTax.map((li: any) =>
                              li?.is_new_purchase === true ? { ...li, discount_code: "" } : li
                          )
                        : lineItemsWithTax;
                const feeSubAll = (formik.values.specialFees || []).reduce(
                    (s: number, f: any) => s + Number(f?.amount || 0),
                    0
                );
                const grand = Number(formik.values.totals?.grand_total ?? (installSub + feeSubAll + productSub + installTax + feeTax + productTax));

                // Optional strings for backend fields that are string-typed
                const installationTaxPctStr = formik.values.calc_install_rate_str || "";   // string
                const overallTaxPctStr = formik.values.calc_overall_rate_str || "";       // string

                // ✅ Build specialfee array for payload (use enriched data from formik which has tax_amount)
                const feeRows = (formik.values.specialFees || []).map((f: any) =>
                    mapInstallationSpecialFeeForSubmit(f, { catalog: allAvailableSpecialFees })
                );

                // console.log("Fee rows for payload:", feeRows);

                // console.log("Payload to send:", {
                //     // order_number: installationOrder?.order_number,
                //     // inventory_source: inventorySource,
                //     // source_id: sourceId,
                //     // brokerage_firm_id: selectedBrokerageFirm?.value,
                //     // brokerage_firm_name: selectedBrokerageFirm?.label,
                //     // team_member_id: values.teamMemberId,
                //     // office: officeInfo,
                //     // agent_id: agentId,
                //     // agent_name: agentName,
                //     // signage_id: userId,
                //     // signage_company_name: userName,
                //     line_items: lineItems,
                //     // customer_group_id: null,
                //     // payment_method: values.payment_method,
                //     installation_details: {
                //         scheduled_date: new Date(values.scheduled_date).toISOString(),
                //         installation_address: installationAddress,
                //         installer_id: selectedInstaller?.value || null,
                //         installer_name: null,
                //         contact_number: null,
                //         estimated_duration: null,
                //         actual_installation_date: null,
                //         additional_instructions: [
                //             {
                //                 value: values.instructions,
                //                 added_by: {
                //                     id: userId,
                //                     name: userName,
                //                 },
                //                 added_at: new Date().toISOString(),
                //             },
                //         ],
                //         assignee_id: null,
                //         tax_details: null,
                //     },
                //     billing_address: selectedBillingAddress,
                //     both_address_same: values.isSameAsBilling,
                //     additional_instructions: values.instructions,
                //     order_type: "installation",
                //     // local_laws_compliance: true,
                //     priority: values.priority,
                //     uploaded_files: uploadedFileMeta || [],
                //     additional_cost: 0,
                //     version: installationOrder?.version,
                //     gate_access_code: values.gatecode || "",
                //     // tax_inclusive: false,
                //     // tax_details: null,
                //     subtotal_amount: installSub,                         // SubtotalAmount
                //     installation_cost: parseFloat(String(installationCost)) || 0, // InstallationCost
                //     // âœ… Totals from engine
                //     total_amount: grand,                                          // TotalAmount

                //     // âœ… Tax fields
                //     special_fee_amount: feeSubAll,                                   // SpecialFeeAmount
                //     special_fee_tax_amount: feeTax,                               // SpecialFeeTaxAmount
                //     special_fee_tax_percentage: specialFeeTaxPct,              // SpecialFeeTaxPercentage (float64 pointer)
                //     installation_tax_amount: installTax,                          // InstallationTaxAmount
                //     installation_tax_percentage: installationTaxPctStr || undefined, // InstallationTaxPercentage (string pointer)
                //     overall_tax_percentage: overallTaxPctStr || undefined,        // OverAllTaxPercentage (string pointer)
                //     over_all_tax_amount: installTax + feeTax,                     // OverAllTaxAmount
                //     tax_inclusive: false,
                //     discount_amount: formik.values.discount_amount || 0,         // DiscountAmount
                //     discount_code: formik.values.discount_code,                       // CouponCode
                //     specialfee: feeRows,                                              // âœ… Array of special fees
                // });
                const toStringPct = (v: any) => {
                    if (v === null || v === undefined || v === "") return "0";
                    const n = Number(v);
                    return Number.isFinite(n) ? String(n) : "0";
                };

                updateOrderPayload = sanitizeInstallationOrderSubmitPayload({
                    line_items: lineItemsMerged,
                    installation_post: installationPost ?? installationOrder?.installation_post ?? undefined,
                    user_email: values.userEmail,
                    user_phone: values.userPhone,
                    installation_details: {
                        scheduled_date: new Date(values.scheduled_date).toISOString(),
                        installation_address: installationAddress,
                        ...buildInstallationDetailsParticipantFields({
                          role: "vendor",
                          selection: selectedInstaller,
                          fallbackOrgId:
                            selectedInstaller?.value ||
                            installationOrder?.installation_details?.installer_org_id ||
                            installationOrder?.seller_org_id ||
                            null,
                          fallbackMembershipId:
                            selectedInstaller?.membershipId ||
                            installationOrder?.installation_details?.installer_membership_id ||
                            null,
                          fallbackGlobalUserId:
                            selectedInstaller?.globalUserId ||
                            installationOrder?.installation_details?.installer_global_user_id ||
                            null,
                          fallbackName:
                            selectedInstaller?.label ||
                            installationOrder?.installation_details?.installer_name ||
                            null,
                        }),
                        estimated_duration: null,
                        actual_installation_date: null,
                        installation_notes: [
                            {
                                value: values.instructions,
                                added_by: {
                                    id: userId,
                                    name: userName,
                                },
                                added_at: new Date().toISOString(),
                            },
                        ],
                        tax_details: null,
                    },
                    billing_address: selectedBillingAddress,
                    both_address_same: values.isSameAsBilling,
                    additional_instructions: values.instructions,
                    order_type: "installation",
                    priority: values.priority,
                    // uploaded_files: uploadedFileMeta || [],
                    additional_cost: 0,
                    version: installationOrder?.version,
                    gate_access_code: values.gatecode || "",
                    subtotal_amount: installSub,                         // SubtotalAmount
                    installation_cost: (() => {
                        const productDisc = Number(formik.values.product_discount_amount ?? 0);
                        return productDisc > 0
                            ? (parseFloat(String(installationCost)) || 0)
                            : Math.max(0, (parseFloat(String(installationCost)) || 0) - Number(formik.values.discount_amount || 0));
                    })(),                                                          // full when product discount, discounted when job discount
                    total_amount: grand,                                          // TotalAmount

                    installation_tax_amount: installTax,                          // InstallationTaxAmount
                    installation_tax_percentage: toStringPct(installationTaxPctStr),
                    over_all_tax_percentage: toStringPct(overallTaxPctStr),
                    over_all_tax_amount: installTax + feeTax + productTax,        // OverAllTaxAmount (include product tax)
                    tax_inclusive: false,
                    // Product discount: line_items only. Installation discount: order level only.
                    discount_amount:
                        submitDiscountScope === "installation"
                            ? Number(formik.values.discount_amount || 0)
                            : 0,
                    discount_code: submitDiscountScope === "installation" ? rootDiscountCode : "",
                    specialfee: feeRows,                                              // ✅ Array of special fees
                    ...installationPartyIdentityFromSavedOrder(installationOrder as Record<string, unknown>),
                });

                const response = await fetch(`${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(updateOrderPayload),
                }
                );

                if (!response.ok) {
                    const error = await response.json();
                    throw new Error(error.message || "Failed to update installation");
                }

                showSuccess("Installation updated successfully!");

                // âœ… Trigger 2: Agent Installation Order Edit (by Signage) - Send notifications
                try {
                    const { createNotification } = await import("../../services/notificationApi");
                    const { getAgentInstallationOrderEditContent } = await import("../../services/notificationContent");
                    const { fetchUserData } = await import("../../utils/userDataFetcher");

                    // Fetch updated order data
                    const orderResponse = await fetch(
                        `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}`,
                        {
                            method: "GET",
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    if (orderResponse.ok) {
                        const orderData = await orderResponse.json();
                        const orderNumber = orderData?.order_number || installationId;

                        // Get current user's license type to determine if they're signage
                        let currentUserLicenseType = "AGENT";
                        if (userId) {
                            try {
                                const currentUserData = await fetchUserData(userId, token || "");
                                currentUserLicenseType = currentUserData?.licenseType || "AGENT";
                            } catch (err) {
                                safeConsole.warn("Failed to fetch current user data:", err);
                            }
                        }

                        // Use userId (the agent who created the order) as end user
                        const endUserId = userId || orderData?.agent_membership_id || orderData?.agent_id || "";
                        let supplierName = "Supplier";

                        // Get selected installer membership
                        const installerMembershipId = resolveInstallationSellerMembershipId(
                          orderData,
                          selectedInstaller
                        );

                        if (installerMembershipId) {
                            try {
                                const supplierData = await fetchUserData(installerMembershipId, token || "");
                                supplierName = supplierData?.companyName || supplierData?.firmDetails?.companyName || supplierName;
                            } catch (err) {
                                safeConsole.warn("Failed to fetch supplier data:", err);
                            }
                        }

                        // Notify End User (Agent)
                        if (endUserId && token) {
                            const agentContent = getAgentInstallationOrderEditContent({
                                orderId: orderNumber,
                                supplierName,
                                recipientType: "agent",
                            });
                            await createNotification(endUserId, agentContent, token, "agent");
                        }

                        // Notify Selected Installer (Signage Admin/Team Member)
                        if (installerMembershipId && token) {
                            try {
                                const installerData = await fetchUserData(installerMembershipId, token || "");
                                const installerLicenseType = installerData?.licenseType || "SIGNAGE_FIRM";
                                const installerRecipientType = installerLicenseType === "SIGNAGE_FIRM" ? "signage_admin" : "team_member";

                                const installerContent = getAgentInstallationOrderEditContent({
                                    orderId: orderNumber,
                                    supplierName,
                                    recipientType: installerRecipientType,
                                });
                                await createNotification(installerMembershipId, installerContent, token, installerRecipientType);
                            } catch (err) {
                                safeConsole.warn(`Failed to send notification to selected installer ${installerMembershipId}:`, err);
                            }
                        }
                    }
                } catch (notifError) {
                    safeConsole.warn("Failed to send installation order edit notification:", notifError);
                    // Don't block the update if notification fails
                }

                // Backend sends "Agent Installation order edit" emails after update.
                // try {
                //     const from = process.env.REACT_APP_FROM_EMAIL2 || "noreply@realesy.com";
                //     if (from && installationId && token) {
                //         await sendInstallationOrderTriggerEmail({
                //             triggerName: "Agent Installation order edit",
                //             installationOrderId: String(installationId),
                //             token,
                //             fromEmail: from,
                //         });
                //     }
                // } catch (emailError) {
                //     safeConsole.error("Failed to send installation edit emails:", emailError);
                // }

                // // Navigate to view mode with a small delay to ensure the success message is shown
                setTimeout(() => {
                    safeNavigate(`/agent/jobs/viewInstallation/${installationId}`, { state: { type: "View" }, replace: true });
                    // Reload the page to ensure fresh data is loaded and avoid version mismatch errors
                    window.location.reload();
                }, 500);
            } catch (error: any) {
                const userEmailError = error?.response?.data?.userEmail;
                const userPhoneError = error?.response?.data?.userPhone;

                if (userEmailError) {
                    formik.setFieldError("userEmail", userEmailError);
                    formik.setFieldTouched("userEmail", true, false);
                }

                if (userPhoneError) {
                    formik.setFieldError("userPhone", userPhoneError);
                    formik.setFieldTouched("userPhone", true, false);
                }

                if (userEmailError || userPhoneError) {
                    setFormSubmitting(false);
                    setUploadProgress(0);
                    return;
                }

                safeConsole.error(error);
                showError(`Error: ${error.message}`);
                await handleApiError(error, {
                    module: "installation",
                    action: "Agent_View_Installation_update_installation_order",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
                    method: "PATCH",
                    requestBody: updateOrderPayload,
                }, token);
            } finally {
                setFormSubmitting(false);
                setUploadProgress(0);
            }
        },
    });

    useEffect(() => {
        if (formik.submitCount < 1) return;

        formik.setTouched(
            {
                ...formik.touched,
                userEmail: true,
                userPhone: true,
                installer: true,
                priority: true,
                billingAddressId: true,
                installationAddressId: true,
                scheduled_date: true,
            },
            false
        );
    }, [formik.submitCount]);

    useEffect(() => {
        if (formik.submitCount < 1) return;
        if (!formik.errors?.scheduled_date) return;
        const el = document.getElementById("scheduled_date");
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus();
    }, [formik.submitCount, formik.errors?.scheduled_date]);

    const uploadFile = async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uploadDir", "installation_orders");

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${process.env.REACT_APP_API_URL}/images/upload`, true);
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    setUploadProgress((event.loaded / event.total) * 100);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200 || xhr.status === 201) {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response.path);
                } else {
                    reject(new Error("Failed to upload file"));
                }
            };

            xhr.onerror = () => reject(new Error("Network error during file upload"));
            xhr.send(formData);
        });
    };

    const handleLocationChange = (
        selectedOption: SingleValue<{ value: string; label: string }>
    ) => {
        formik.setFieldValue("location", selectedOption?.value || "");
    };

    const handleMapClick = useCallback((event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            setSelectedLocation({ lat, lng });
            formik.setFieldValue("location", { lat, lng });
        }
    }, []);


    // seting the total units based on the selected products
    useEffect(() => {
        const newTotal = selectedProducts.reduce((sum, product) => sum + (product.quantity || 0), 0);
        setTotalUnits(newTotal);
        // console.log("total units:", newTotal);
    }, [selectedProducts]);

    // seting the installation address based on the selected billing address
    useEffect(() => {
        if (formik.values.isSameAsBilling) {
            const billing = selectedBillingAddress;

            if (billing) {
                // console.log("Billing Address:", billing);
                setInstallationAddress(billing);
                formik.setFieldValue("installationAddressId", `${billing.label}: ${billing.address_details.addressLine1}, ${billing.address_details.city}, ${billing.address_details.state}, ${billing.address_details.zip ? billing.address_details.zip : ''}`);
            }
        }
    }, [formik.values.isSameAsBilling, selectedBillingAddress]);

    // âœ… Totals are now calculated by tax engine, not needed here
    // useEffect(() => {
    //     const subtotal = Number(installationCost) + Number(formik.values.tax);
    //     const total = subtotal - Number(formik.values.discount || 0);

    //     formik.setFieldValue("subtotal", subtotal);
    //     formik.setFieldValue("total", total);
    // }, [installationCost, formik.values.tax, formik.values.discount]);

    // remove the preview images
    useEffect(() => {
        return () => {
            imagePreviews.forEach((url) => URL.revokeObjectURL(url));
        };
    }, [imagePreviews]);

    useEffect(() => {
        if (
            installationAddress?.address_details?.latitude &&
            installationAddress?.address_details?.longitude &&
            installationAddress?.address_details?.latitude !== 0 &&
            installationAddress?.address_details?.longitude !== 0
        ) {
            // console.log("Setting marker from installationAddress");
            setSelectedLocation({
                lat: installationAddress?.address_details?.latitude,
                lng: installationAddress?.address_details?.longitude,
            });
        }
    }, [installationAddress]);

    const handleMarkerDragEnd = async (event: google.maps.MapMouseEvent) => {
        const lat = event.latLng?.lat();
        const lng = event.latLng?.lng();

        if (!lat || !lng) return;

        setSelectedLocation({ lat, lng });

        try {
            const geocoder = new window.google.maps.Geocoder();
            const response = await geocoder.geocode({ location: { lat, lng } });

            if (response.results[0]) {
                const place = response.results[0];
                const addressComponents = place.address_components;

                const getComponent = (type: string) => {
                    const component = addressComponents?.find((c: any) =>
                        c.types.includes(type)
                    );
                    return component
                        ? { long_name: component.long_name, short_name: component.short_name }
                        : { long_name: "", short_name: "" };
                };

                const streetNumber = getComponent("street_number").long_name;
                const route = getComponent("route").long_name;
                const cityObj =
                    getComponent("locality") ||
                    getComponent("administrative_area_level_2");
                const stateObj = getComponent("administrative_area_level_1");
                const postalCode = getComponent("postal_code").long_name;
                const countryObj = getComponent("country");

                const street = `${streetNumber} ${route}`.trim();

                const addressDetails: Address = {
                    _id: "",
                    label: place.formatted_address,
                    addressLine1: street,
                    addressLine2: "",
                    country: countryObj.long_name,
                    county: cityObj.long_name,
                    city: cityObj.long_name,
                    state: stateObj.long_name,
                    zip: postalCode,
                    cityCode: cityObj.short_name,
                    stateCode: stateObj.short_name,
                    countryCode: countryObj.short_name,
                    latitude: lat,
                    longitude: lng,
                    phone: "",
                };

                // Build the full Addresses object (matches your imported type)
                const newAddresses: Addresses = {
                    _id: "",
                    user_id: "",
                    user_type: "",
                    label: place.formatted_address,
                    first_name: "",
                    last_name: "",
                    company: "",
                    default_address: false,
                    address_details: addressDetails,
                    created_by: {
                        id: userId || "",
                        name: userName || "",

                    },
                    updated_by: {
                        id: userId || "",
                        name: userName || "",
                    },
                };

                setInstallationAddress(newAddresses);
                formik.setFieldValue("installationAddressId", place.formatted_address);

                // If installation address is changed in edit mode, set isSameAsBilling to false
                if (isEdit) {
                    formik.setFieldValue("isSameAsBilling", false);
                }
                triggerRecomputeWithRef.current?.();
            }
        } catch (error) {
            safeConsole.error("Geocoder failed", error);
            showError("Unable to update address from marker position.");
        }
    };

    useEffect(() => {
        const fetchPaymentMethods = async () => {
            const membershipId = resolveInstallationPaymentMethodsMembershipId(installationOrder);
            const sellerOrgId = resolveInstallationSellerOrganizationId(
                installationOrder?.seller_org_id,
                installationOrder
            );
            if (!membershipId || !sellerOrgId || !token) {
                return;
            }
            try {
                const data = await fetchInstallationPaymentMethods(
                    token,
                    sellerOrgId,
                    membershipId
                );
                setPaymentMethod(Array.isArray(data) ? data : []);
            } catch (err) {
                safeConsole.error("Error fetching payment methods:", err);
                await handleApiError(err, {
                    module: "installation",
                    action: "Agent_View_Installation_fetch_payment_methods",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/payment-methods/organizations/${sellerOrgId}/memberships/${membershipId}`,
                    method: "GET",
                }, token);
            } finally {
                setLoading(false);
            }
        };

        if (userId && installationOrder?.inventory_source) {
            fetchPaymentMethods();
        }
    }, [token, userId, installationOrder?.inventory_source]);

    // setting defult selectedProducts
    useEffect(() => {
        if (installationOrder?.line_items?.length > 0) {
            const mapped = installationOrder.line_items?.map((item: any) => ({
                product_id: item.product_id,
                variant_id: item.variant_id || "",
                inventory_type: item.inventory_source || "",
                name: item.product_name || "Deleted Product",
                sku: item.sku || "",
                product_location_status: item.current_status || "",
                user_id: installationOrder?.agent_id || "",
                quantity: item.quantity,
                updateStatus: "",
                productionStatus: item.production_status || "",
                is_rotational: item.is_rotational,
                storage_locations: item.storage_locations || [],
                availableqty: 0,
                slot_id: item.slot_id || "",
                source_product_id: item.source_product_id || null,
                is_new_purchase: !!item.is_new_purchase,
                is_accessory: !!(item.is_accessories ?? item.is_accessory),
                is_production: item.is_production,
                unit_price: item.unit_price ?? 0,
                unit_retail_price: item.unit_retail_price ?? item.unit_price ?? 0,
                changed_unit_price: item.changed_unit_price ?? item.unit_price ?? 0,
                discount_code: String(item.discount_code ?? ""),
                total_price: item.total_price ?? 0,
                item_sub_total: item.item_sub_total,
                discount: item.discount ?? item.discount_on_total_quantity ?? 0,
                discount_on_total_quantity: item.discount_on_total_quantity ?? item.discount ?? 0,
                images: item.images || [],
                design_id: item.design_id ? String(item.design_id).trim() : undefined,
                design_name: item.design_name ? String(item.design_name).trim() : undefined,
                preview_url: item.preview_url ? String(item.preview_url).trim() : undefined,
            }));

            setSelectedProducts(mapped);
        }
    }, [installationOrder]);

    const [integrations, setIntegrations] = useState<PaymentGateway[]>([]);

    useEffect(() => {
        if (!installationOrder?.seller_org_id) return;
        const fetchIntegrations = async () => {
            try {
                const sellerOrgId = resolveInstallationSellerOrganizationId(
                    installationOrder?.seller_org_id,
                    installationOrder
                );
                const data = await fetchInstallationPaymentGateway(token, sellerOrgId);
                setIntegrations(Array.isArray(data) ? data : data ? [data] : []);
            } catch (err) {
                // showError("Failed to load integrations.");
                setError(err instanceof Error ? err.message : "An unknown error occurred");
                const sellerOrgId = resolveInstallationSellerOrganizationId(
                    installationOrder?.seller_org_id,
                    installationOrder
                );
                await handleApiError(err, {
                    module: "installation",
                    action: "Agent_View_Installation_fetch_integrations",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}${appendPermissionsFalse(`/payments/gateway/organizations/${sellerOrgId}`)}`,
                    method: "GET",
                }, token);
            } finally {
                setLoading(false);
            }
        };

        fetchIntegrations();
    }, [token, installationOrder]);

    const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);


    useEffect(() => {
        const stripeInfo = integrations?.find((method) => method.gateway === "stripe");
        // console.log('Stripe info ', stripeInfo);
        if (stripeInfo && stripeInfo.publishable_key) {
            const promise = loadStripe(stripeInfo.publishable_key);
            setStripePromise(promise);
        }
    }, [integrations]);

    // setting defult billing Address
    useEffect(() => {
        if (!installationOrder) return;

        const billingId =
            installationOrder?.billing_address?._id || formik.values.billingAddressId;
        if (!billingId) return;

        const billingMatch =
            addressObjects?.find(
                (addr) =>
                    addr._id === billingId || addr.address_details?._id === billingId
            ) || installationOrder?.billing_address;

        if (billingMatch && (!selectedBillingAddress || selectedBillingAddress._id !== billingMatch._id)) {
            setSelectedBillingAddress(billingMatch);
            formik.setFieldValue("billingAddressId", billingId);
        }
    }, [installationOrder, addressObjects, formik.values.billingAddressId]);


    // Helper function to send payment applied emails for installation orders
    const sendInstallationPaymentAppliedEmails = async (
        updatedOrder: any,
        paymentAmountValue: number,
        paymentMethodName: string,
        fromEmail: string
    ) => {
        if (!fromEmail || !updatedOrder) {
            safeConsole.warn("sendInstallationPaymentAppliedEmails: Missing fromEmail or updatedOrder", { fromEmail: !!fromEmail, updatedOrder: !!updatedOrder });
            return;
        }

        try {
            safeConsole.log("sendInstallationPaymentAppliedEmails: Starting email send", {
                orderId: updatedOrder._id || updatedOrder.id,
                paymentAmountValue,
                paymentMethodName
            });

            // Import user data fetcher
            const { fetchUserData } = await import("utils/userDataFetcher");

            // Format order ID
            const orderId = `#${updatedOrder.order_number || updatedOrder._id || updatedOrder.id || "INST-XXXX"}`;

            // Get payment details from updated order
            const paymentInfoArray = Array.isArray(updatedOrder.payment_info) ? updatedOrder.payment_info : [];
            const latestPayment = paymentInfoArray.length > 0 ? paymentInfoArray[paymentInfoArray.length - 1] : null;

            // Format payment amount - use latest payment if available, otherwise use the passed value
            const paymentAmount = latestPayment?.amount_paid
                ? `$${Number(latestPayment.amount_paid).toFixed(2)}`
                : `$${Number(paymentAmountValue).toFixed(2)}`;

            // Format payment date
            const paymentDate = latestPayment?.payment_date
                ? new Date(latestPayment.payment_date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
                : new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

            // Format payment method
            const formattedPaymentMethod = paymentMethodName === "online"
                ? "Credit Card"
                : paymentMethodName === "bank_transfer"
                    ? "Bank Transfer"
                    : paymentMethodName === "cheque"
                        ? "Cheque"
                        : paymentMethodName;

            // Calculate remaining balance from updated order
            const totalPaidAfter = paymentInfoArray.reduce(
                (acc: number, p: any) => acc + Number(p?.amount_paid || 0),
                0
            );
            const remainingBalance = Math.max(0, Number(updatedOrder.total_amount || 0) - totalPaidAfter);
            const currentBalance = remainingBalance > 0 ? `$${remainingBalance.toFixed(2)}` : "$0.00";

            // Determine who applied the payment - get current user from membership id
            const currentUserId = membershipId;
            let currentUserData = null;
            if (currentUserId) {
                currentUserData = await fetchUserData(currentUserId, token);
            }

            const currentUserLicenseType = currentUserData?.licenseType || getAuthCookie("licenseType") || "";
            const currentUserEmail = currentUserData?.email || "";
            const currentUserName = currentUserData?.firstName ? `${currentUserData.firstName} ${currentUserData.lastName || ""}`.trim() : userName || "";

            let userRoleName = "User";
            if (currentUserLicenseType === "SIGNAGE_FIRM") {
                userRoleName = "Signage Admin";
            } else if (currentUserLicenseType === "SIGNAGE_TEAM_MEMBER") {
                userRoleName = "Signage Team Member";
            } else if (currentUserLicenseType === "BROKERAGE_FIRM") {
                userRoleName = "Brokerage Firm Admin";
            } else if (currentUserLicenseType === "BROKERAGE_TEAM_MEMBER") {
                userRoleName = "Brokerage Team Member";
            } else if (currentUserLicenseType === "AGENT" || currentUserLicenseType === "BROKERAGE_AGENT") {
                userRoleName = "Agent";
            }

            const paidByUser = (latestPayment as any)?.paid_by?.name || currentUserName || "User";
            const paidByEmail = (latestPayment as any)?.paid_by?.email || currentUserEmail || "";
            const paymentAppliedBy = `${userRoleName} (${paidByEmail})`;

            // Get agent name and brokerage firm name
            const agentName = updatedOrder.agent_name || "N/A";
            const brokerageFirm = updatedOrder.brokerage_firm_name || "N/A";

            // Format property address
            const propertyAddr = updatedOrder.installation_details?.installation_address?.address_details
                ? `${updatedOrder.installation_details.installation_address.address_details.addressLine1 || ""}, ${updatedOrder.installation_details.installation_address.address_details.city || ""}, ${updatedOrder.installation_details.installation_address.address_details.state || ""} ${updatedOrder.installation_details.installation_address.address_details.zip || ""}`.trim().replace(/^,\s*|,\s*$/g, "")
                : updatedOrder.installation_details?.installation_address
                    ? `${updatedOrder.installation_details.installation_address.addressLine1 || ""}, ${updatedOrder.installation_details.installation_address.city || ""}, ${updatedOrder.installation_details.installation_address.state || ""} ${updatedOrder.installation_details.installation_address.zip || ""}`.trim().replace(/^,\s*|,\s*$/g, "")
                    : "N/A";

            // Build base URL for order links
            const baseUrl = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
            const viewOrderUrl = `${baseUrl}/agent/jobs/viewInstallation/${updatedOrder._id || updatedOrder.id}`;

            // Common email parameters
            const commonParams: Record<string, string> = {
                orderId: orderId,
                agentName: agentName,
                brokerageFirm: brokerageFirm,
                propertyAddress: propertyAddr,
                paymentAppliedBy: paymentAppliedBy,
                paymentAmount: paymentAmount,
                paymentDate: paymentDate,
                paymentMethod: formattedPaymentMethod,
                currentBalance: currentBalance,
                viewOrderUrl: viewOrderUrl,
            };

            // await sendInstallationOrderTriggerEmail({
            //     triggerName: "Signage Payment applied for Installation Job",
            //     installationOrderId: String(updatedOrder?._id || updatedOrder?.id || ""),
            //     token: token || "",
            //     fromEmail,
            //     includeOrderPdfAttachment: true,
            //     extraParams: commonParams,
            // });
        } catch (emailError) {
            safeConsole.error("Failed to send payment applied emails:", emailError);
            // Don't block payment success if email fails, but log the error for debugging
        }
    };

    const completeOrder = async (method: { name: string; _id: string }) => {
        console.log("method", method);
        setLoading(true);
        let paymentSucceeded = false;

        // Find the selected payment method to check is_credit
        const selectedPaymentMethod = paymentMethod.find(pm => pm._id === method._id);
        const isCreditPayment = selectedPaymentMethod?.is_credit || false;

        try {
            // if (["cheque", "bank_transfer"].includes(method.name)) {
            //     // ðŸ” Call Net30-style API
            //     const latestPayment = installationOrder?.payment_info?.[0]?.amount_due;
            //     console.log("latestPayment", latestPayment);
            //     const lastAmountDue = latestPayment ?? formik.values.total;
            //     console.log("lastAmountDue", lastAmountDue);
            //     const response = await fetch(
            //         `${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}/net30_payment`,
            //         {
            //             method: "POST",
            //             headers: {
            //                 "Content-Type": "application/json",
            //                 Authorization: `Bearer ${token}`, // use token from context
            //             },
            //             body: JSON.stringify({
            //                 payment_id: formik.values.transactionId || "",
            //                 method: method.name,
            //                 amount_paid: formik.values.partial_amount,
            //                 total_amount: lastAmountDue,
            //                 amount_due: Math.max(0, lastAmountDue - formik.values.partial_amount),
            //                 payment_date: new Date().toISOString(),
            //             }),
            //         }
            //     );

            //     if (!response.ok) {
            //         throw new Error("Cheque/Bank payment failed.");
            //     }

            // } else {
            // ðŸ” Default online payment API
            // Calculate payment amounts based on credit status
            const amountPaid = isCreditPayment ? 0 : remaingamount;
            const amountDue = isCreditPayment ? remaingamount : 0;

            // console.log("Online payment - Amount Paid:", amountPaid, "Amount Due:", amountDue);

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}/payment`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        payment_id: "",
                        total_amount: formik.values.total,
                        amount_paid: amountPaid,
                        amount_due: amountDue,
                        payment_date: new Date().toISOString(),
                        method: method.name,
                        paid_by: buildLoggedInPaymentPaidBy({
                            name: userName,
                            membership_id: membershipId || userId,
                            global_user_id: globalUserId,
                            organization_id: organizationId,
                        }),
                        payment_status: installationOrder?.payment_status ?? "",
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Online payment failed.");
            }

            // Wait a moment for backend to process payment before fetching updated order
            await new Promise(resolve => setTimeout(resolve, 500));

            // Fetch updated order to get latest payment info (with retry)
            let updatedOrder = installationOrder;
            let retries = 3;
            while (retries > 0) {
                try {
                    const updatedOrderRes = await fetch(`${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    if (updatedOrderRes.ok) {
                        const fetchedOrder = await updatedOrderRes.json();
                        // Check if payment_info has been updated (has at least one payment)
                        if (Array.isArray(fetchedOrder.payment_info) && fetchedOrder.payment_info.length > 0) {
                            updatedOrder = fetchedOrder;
                            break;
                        } else if (retries === 1) {
                            // Last retry, use fetched order even if payment_info is empty
                            updatedOrder = fetchedOrder;
                        }
                    }
                } catch (fetchErr) {
                    safeConsole.warn(`Failed to fetch updated order (retries left: ${retries - 1}):`, fetchErr);
                }
                if (retries > 1) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                }
                retries--;
            }

            // Send "Signage Payment applied for Installation Job" emails after successful payment
            const from = process.env.REACT_APP_FROM_EMAIL2;
            if (from) {
                try {
                    await sendInstallationPaymentAppliedEmails(updatedOrder, amountPaid, method.name, from);
                } catch (emailErr) {
                    safeConsole.error("Failed to send payment emails:", emailErr);
                    // Don't block payment success, but log the error
                }
            }
            // }

            showSuccess("Payment submitted successfully!");
            localStorage.removeItem("cart_id");
            paymentSucceeded = true;

        } catch (error) {
            const errMessage =
                (error as Error).message || "An unknown error occurred";
            safeConsole.error("Order Failed:", errMessage);
            showError(`Error: ${errMessage}`);
        } finally {
            setLoading(false);
            if (paymentSucceeded) {
                safeNavigate(0);
            }
        }
    };


    const handleInstallationStatus = async (nextStatus: number) => {
        if (!installationId || !token) return;

        setLoading(true);

        let url = "";
        let body: any = undefined;
        try {

            const scheduledDate = installationOrder?.installation_details?.scheduled_date;

            let shouldMakeApiCall = true;
            switch (nextStatus) {
                case 200: // Finalize
                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/finalize`;
                    break;

                case 300: // Scheduled
                case 500: // Completed
                    // Status 300/500 might be set by supplier when scheduling/completing
                    // Skip API call but still allow email sending
                    shouldMakeApiCall = false;
                    url = "";
                    break;

                case 600:
                    let refundSuccess = false;
                    let nextTaxStatus = installationOrder?.tax_status || "draft";

                    try {
                        const forceType =
                            installationOrder?.tax_status === "complete" ? "taxcloud" : undefined;

                        refundSuccess = await (
                            installationTaxRef.current?.recalculate?.(forceType, {
                                allowRefund: true,
                            }) ?? false
                        );

                        // console.log("[INSTALL:ORDER_SUBMIT] tax recalc result:", { refundSuccess });

                        // ðŸ‘‰ RUN THIS ONLY IF refund is successful
                        if (refundSuccess) {
                            const order_type = installationOrder?.order_type || "installation";

                            const res = await PostVersionOrdernumber(
                                token,
                                installationOrder?.order_number || "",
                                order_type
                            );

                            // console.log("[INSTALL:ORDER_SUBMIT] TaxCloud refund result:", { res });

                            if (!res) throw new Error("TaxCloud refund failed");

                            nextTaxStatus = "draft";
                        } else {
                            console.log("[INSTALL:ORDER_SUBMIT] Refund NOT successful â†’ skipping PostVersionOrdernumber");
                        }

                    } catch (err) {
                        safeConsole.error("[INSTALL:ORDER_SUBMIT] tax recalc failed", err);
                    }

                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/cancel`;
                    body = { note: formik.values.instructions };
                    break;

                default:
                    showError("Invalid status selected");
                    setLoading(false);
                    return;
            }

            let result: any = {};
            if (shouldMakeApiCall && url) {
                const statusUpdatePayload = body || {};
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    ...(body ? { body: JSON.stringify(body) } : {}), // only include body if defined
                });

                result = await response.json();
                if (!response.ok) throw new Error(result?.error || "Status update failed");

                showSuccess(result.message || "Installation status updated");
            } else {
                // For statuses 300/500, status might already be updated elsewhere
                // Just update local state and show success
                showSuccess("Installation status updated");
            }

            setInstallationOrder((prev: any) => ({ ...prev, status: nextStatus }));

            // âœ… Trigger 3, 4, 5: Agent Installation Order Status Updates - Send notifications
            if (nextStatus === 300 || nextStatus === 500 || nextStatus === 600) {
                try {
                    const { createNotification } = await import("../../services/notificationApi");
                    const {
                        getAgentInstallationOrderScheduledContent,
                        getAgentInstallationOrderCompletedContent,
                        getAgentInstallationOrderCanceledContent
                    } = await import("../../services/notificationContent");
                    const { fetchUserData } = await import("../../utils/userDataFetcher");

                    // Fetch updated order details
                    const orderResponse = await fetch(
                        `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}`,
                        {
                            method: "GET",
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    if (orderResponse.ok) {
                        const orderData = await orderResponse.json();
                        const orderNumber = orderData?.order_number || installationId;
                        const supplierMembershipId = resolveInstallationSellerMembershipId(
                          orderData,
                          selectedInstaller
                        );
                        let supplierName = "Supplier";

                        if (supplierMembershipId) {
                            try {
                                const supplierData = await fetchUserData(supplierMembershipId, token || "");
                                supplierName = supplierData?.companyName || supplierData?.firmDetails?.companyName || supplierName;
                            } catch (err) {
                                safeConsole.warn("Failed to fetch supplier data:", err);
                            }
                        }

                        // Use userId (the agent who created the order) as end user
                        const endUserId = userId || orderData?.agent_membership_id || orderData?.agent_id || "";

                        // Get selected installer membership (check state first, then order data)
                        const installerId = supplierMembershipId;

                        if (nextStatus === 300) {
                            // Trigger 3: Scheduled
                            const scheduledDate = orderData?.installation_details?.scheduled_date
                                ? new Date(orderData.installation_details.scheduled_date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
                                : new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

                            // Notify End User (Agent)
                            if (endUserId && token) {
                                const agentContent = getAgentInstallationOrderScheduledContent({
                                    orderId: orderNumber,
                                    scheduledDate,
                                    supplierName,
                                    recipientType: "agent",
                                });
                                await createNotification(endUserId, agentContent, token, "agent");
                            }
                            // Note: Installer notifications for Scheduled status removed as getAgentInstallationOrderScheduledContent doesn't support signage_admin/team_member
                        } else if (nextStatus === 500) {
                            // Trigger 4: Completed
                            // Notify End User (Agent)
                            if (endUserId && token) {
                                const agentContent = getAgentInstallationOrderCompletedContent({
                                    orderId: orderNumber,
                                    supplierName,
                                    recipientType: "agent",
                                });
                                await createNotification(endUserId, agentContent, token, "agent");
                            }
                            // Note: Installer notifications for Completed status removed as getAgentInstallationOrderCompletedContent doesn't support signage_admin/team_member
                        } else if (nextStatus === 600) {
                            // Trigger 5: Canceled
                            // Notify End User (Agent)
                            if (endUserId && token) {
                                const agentContent = getAgentInstallationOrderCanceledContent({
                                    orderId: orderNumber,
                                    recipientType: "agent",
                                });
                                await createNotification(endUserId, agentContent, token, "agent");
                            }
                            // Note: Installer notifications for Canceled status removed as getAgentInstallationOrderCanceledContent doesn't support signage_admin/team_member
                        }
                    }
                } catch (notifError) {
                    safeConsole.warn("Failed to send installation status notification:", notifError);
                    // Don't block the status update if notification fails
                }
            }

            // Backend sends Agent Installation Order Scheduled/Completed/Canceled emails.
            // if (nextStatus === 300 || nextStatus === 500 || nextStatus === 600) {
            //     try {
            //         const from = process.env.REACT_APP_FROM_EMAIL2 || "noreply@realesy.com";
            //         if (from && installationId && installationOrder && token) {
            //             const triggerMap: Record<number, "Agent Installation Order Scheduled" | "Agent Installation Order Completed" | "Agent Installation Order Canceled"> = {
            //                 300: "Agent Installation Order Scheduled",
            //                 500: "Agent Installation Order Completed",
            //                 600: "Agent Installation Order Canceled",
            //             };
            //             const mappedTrigger = triggerMap[nextStatus];
            //
            //             if (mappedTrigger) {
            //                 const extraParams: Record<string, string> = {};
            //                 if (nextStatus === 600) {
            //                     extraParams.cancellationReason = formik.values.instructions || result?.note || "Not specified";
            //                     extraParams.canceledBy = userName || "System";
            //                 }
            //
            //                 await sendInstallationOrderTriggerEmail({
            //                     triggerName: mappedTrigger,
            //                     installationOrderId: String(installationId),
            //                     token,
            //                     fromEmail: from,
            //                     installationStatusCode: nextStatus,
            //                     extraParams,
            //                 });
            //             }
            //         }
            //     } catch (emailError) {
            //         safeConsole.warn("Failed to send installation status update emails:", emailError);
            //     }
            // }
        } catch (err: any) {
            safeConsole.error("Status update error:", err.message);
            showError(err.message || "Something went wrong");
            await handleApiError(err, {
                module: "installation",
                action: "Agent_View_Installation_handle_installation_status",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: url || "",
                method: "POST",
                requestBody: body,
                additionalInfo: { nextStatus },
            }, token);
        } finally {
            setLoading(false);
        }
    };

    const totalPaid = (installationOrder?.payment_info ?? []).reduce(
        (acc: number, payment: { amount_paid?: number | string }) =>
            acc + Number(payment.amount_paid || 0),
        0
    );

    const maxAllowed = (installationOrder?.payment_info ?? []).length > 0 ? Number((Number(installationOrder?.total_amount || 0) - totalPaid).toFixed(2)) : Number(installationOrder?.total_amount || 0);

    const statusHistory: any[] = Array.isArray(installationOrder?.status_history)
        ? (installationOrder?.status_history as any[])
        : [];
    // console.log("statusHistory", statusHistory);
    const paymentInfo: PaymentInfoItem[] = [...(installationOrder?.payment_info || [])];

    const resolveOrderStatus = (status: number | undefined): string => {
        switch (status) {
            case null: return "";
            case 100: return "Draft";
            case 200: return "Finalized";
            case 300: return "Scheduled";
            case 400: return "In Progress";
            case 500: return "Completed";
            case 600: return "Canceled";
            default: return status !== undefined ? `Status ${status}` : "Unknown";
        }
    };


    const parseDate = (input: any): string => {
        try {
            return new Date(input).toLocaleString();
        } catch {
            return "Invalid Date";
        }
    };
    const approvedProofCards = useMemo(() => {
        const approvedRoot = (approvedMessageData as any) || {};
        const approvedFiles = Array.isArray(approvedRoot?.approved_files) ? approvedRoot.approved_files : [];
        if (approvedFiles.length === 0) return [];

        const grouped = new Map<number, any[]>();
        approvedFiles.forEach((f: any) => {
            const version = Number(f?.version);
            const key = Number.isFinite(version) && version > 0 ? Math.floor(version) : 1;
            if (!grouped.has(key)) grouped.set(key, []);
            grouped.get(key)!.push(f);
        });

        return Array.from(grouped.entries())
            .sort((a, b) => a[0] - b[0])
            .map(([version, files]) => {
                const first = files[0] || {};
                const compactProofFiles = files.map((f: any, idx: number) => ({
                    id: String(f?.id ?? f?._id ?? idx),
                    name: String(f?.original_name ?? f?.file_name ?? f?.name ?? "File"),
                    href:
                        String(f?.preview_url ?? "").trim() ||
                        String(f?.file_url ?? f?.url ?? "").trim(),
                    previewUrl: String(f?.preview_url ?? f?.file_url ?? f?.url ?? "").trim(),
                    fileId: String(f?.file_id ?? "").trim(),
                    quantity: Number.isFinite(Number(f?.quantity)) ? Number(f?.quantity) : undefined,
                    sizeLabel: Number.isFinite(Number(f?.file_size)) ? `${Math.round(Number(f?.file_size) / 1024)} KB` : "â€”",
                }));
                const approvedByName = String(
                    first?.design_approved_by?.name ??
                    first?.updated_by?.name ??
                    approvedRoot?.design_approved_by?.name ??
                    approvedRoot?.approved_by_name ??
                    installationOrder?.design_approved_by?.name ??
                    installationOrder?.project?.design_approved_by?.name ??
                    ""
                ).trim();
                const approvedAtRaw =
                    first?.design_approved_at ??
                    first?.updated_at ??
                    approvedRoot?.design_approved_at ??
                    approvedRoot?.approved_at ??
                    installationOrder?.design_approved_at ??
                    installationOrder?.project?.design_approved_at;
                const approvedAtLabel = approvedAtRaw ? parseDate(approvedAtRaw) : "";
                const shippingName = String(
                    first?.shipping_method?.name ??
                    approvedRoot?.shipping_method?.name ??
                    installationOrder?.shipping_method?.name ??
                    ""
                ).trim();
                const shippingDesc = String(
                    first?.shipping_method?.description ??
                    approvedRoot?.shipping_method?.description ??
                    installationOrder?.shipping_method?.description ??
                    ""
                ).trim();
                const shippingAmountRaw = first?.shipping_amount ?? approvedRoot?.shipping_amount;
                const shippingAmountLabel = Number.isFinite(Number(shippingAmountRaw))
                    ? `$${Number(shippingAmountRaw).toFixed(2)}`
                    : "";
                const assignedToName = String(
                    approvedRoot?.assigned_to_name ??
                    installationOrder?.assigned_to_name ??
                    installationOrder?.project?.assigned_to_name ??
                    ""
                ).trim();
                const billingAddress =
                    first?.billing_address ??
                    approvedRoot?.billing_address ??
                    installationOrder?.billing_address ??
                    null;
                const installationAddress =
                    installationOrder?.installation_details?.installation_address ??
                    first?.shipping_address ??
                    approvedRoot?.shipping_address ??
                    null;
                return {
                    version,
                    files: compactProofFiles,
                    approvedByName,
                    approvedAtLabel,
                    assignedToName,
                    shippingName,
                    shippingDesc,
                    shippingAmountLabel,
                    billingAddress,
                    installationAddress,
                };
            });
    }, [approvedMessageData, installationOrder]);

    // Function to update gate access code only
    const handleSaveGateCode = async () => {
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
                {
                    version: installationOrder?.version,
                    gate_access_code: formik.values.gatecode,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                showSuccess("Gate access code updated successfully!");
                // Refresh the order details instead of reloading the page
                await fetchOrderDetails();
            } else {
                showError("Failed to update gate access code");
            }
        } catch (error: any) {
            showError(`Error updating gate access code: ${error.message}`);
        }
    };

    const handleSaveInstructions = (newInstructions: string) => {
        setInstructions(newInstructions);
        formik.setFieldValue("instructions", newInstructions);
    };

    const handleSaveInstructionsOnly = async (
        instructions: string,
        context?: { hasPendingFiles: boolean }
    ) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
                {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        version: installationOrder?.version,
                        additional_instructions: instructions,
                    }),
                }
            );

            if (response.ok) {
                showSuccess("Instructions updated successfully!");
                // Update the local state to reflect the change
                setInstructions(instructions);
                // Also update formik value to keep them in sync
                formik.setFieldValue("instructions", instructions);
                // If files are pending, refresh after file upload finishes in Instructions component.
                if (!context?.hasPendingFiles) {
                    await fetchOrderDetails();
                }
            } else {
                showError("Failed to update instructions");
            }
        } catch (error: any) {
            showError(`Error updating instructions: ${error.message}`);
        }
    };

    useEffect(() => {
        const files = getInstructionUploadedFilesFromOrder(installationOrder);
        if (files.length > 0) {
            setUploadedFileMeta(files);
        }
    }, [installationOrder]);

    useEffect(() => {
        if (!installationOrder) return;
        const option = resolveInstallationInstallerSelectOption(installationOrder, suppliers);
        if (!option) return;
        setSelectedInstaller(option);
        formik.setFieldValue("installer", option.value);
    }, [installationOrder, suppliers]);


    useEffect(() => {
        if (installationOrder) {
            const addr = installationOrder?.installation_details?.installation_address;
            setInstallationAddress(addr);

            // Initialize instructions from installation order
            if (installationOrder?.additional_instructions) {
                const latestInstruction = installationOrder.additional_instructions[installationOrder.additional_instructions.length - 1];
                if (latestInstruction?.value) {
                    setInstructions(latestInstruction.value);
                    formik.setFieldValue("instructions", latestInstruction.value);
                }
            }

            // Initialize gate code from installation order
            if (installationOrder?.gate_access_code) {
                formik.setFieldValue("gatecode", installationOrder.gate_access_code);
            }

            // âœ… Initialize special fees from installation order (use state instead of Formik)
            if (installationOrder?.specialfee && Array.isArray(installationOrder.specialfee)) {
                const mappedFees = installationOrder.specialfee.map((fee: any) =>
                    mapSavedInstallationSpecialFeeToUi(fee)
                );
                // âœ… Update state (primary source)
                setSelectedSpecialFees(mappedFees);
                // Also update Formik for form submission
                formik.setFieldValue("specialFees", mappedFees, false);
                // console.log("âœ… Special fees loaded:", mappedFees);
            } else if (installationOrder && (!installationOrder?.specialfee || !Array.isArray(installationOrder.specialfee) || installationOrder.specialfee.length === 0)) {
                // âœ… Explicitly set empty array if no special fees exist
                setSelectedSpecialFees([]);
                formik.setFieldValue("specialFees", [], false);
            }
        }
    }, [installationOrder]);

    useEffect(() => {
        const fetchPaymentIntent = async () => {
            // const amountToPay = (formik.values.partial_amount === 0
            //   ? (Number(order?.total_amount || 0) - totalPaid)
            //   : formik.values.partial_amount);

            console.log("amountToPay", (formik.values.partial_amount === 0
                ? (Number(installationOrder?.total_amount || 0) - totalPaid)
                : formik.values.partial_amount));


            const paymentIntentPayload = {
                amount: Math.round(
                    Number(
                        formik.values.partial_amount === 0
                            ? Number(installationOrder?.total_amount || 0) - totalPaid
                            : formik.values.partial_amount
                    ) * 100
                ),
                currency: "usd",
                order_id: String(installationOrder?._id || installationOrder?.id || ""),
                order_number: String(installationOrder?.order_number || ""),
                customer_name: String(installationOrder?.user_name || ""),
                customer_email: String(installationOrder?.user_email || ""),
                customer_phone: String(installationOrder?.user_phone || ""),
                payment_method_types: ["card"],
            };

            try {
                const sellerOrgId = resolveInstallationSellerOrganizationId(
                    installationOrder?.seller_org_id,
                    installationOrder
                );
                const data = await createInstallationStripePaymentIntent(token, sellerOrgId, paymentIntentPayload);
                setClientSecret(data.clientSecret || data.client_secret);
            } catch (err) {
                safeConsole.error("Failed to create PaymentIntent:", err);
                const sellerOrgId = resolveInstallationSellerOrganizationId(
                    installationOrder?.seller_org_id,
                    installationOrder
                );
                await handleApiError(err, {
                    module: "installation",
                    action: "Agent_View_Installation_fetch_payment_intent",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/payments/stripe/organizations/${sellerOrgId}/payment-intent`,
                    method: "POST",
                    requestBody: paymentIntentPayload,
                }, token);
            }
        };

        if (stripePromise) fetchPaymentIntent();
    }, [
        stripePromise,
        formik.values.partial_amount,
        installationOrder?.total_amount,
        installationOrder?._id,
        installationOrder?.id,
        installationOrder?.order_number,
        installationOrder?.user_name,
        installationOrder?.user_email,
        installationOrder?.user_phone,
        totalPaid,
    ]);
    const readOnly = !isEdit;

    const installationLogEvents = React.useMemo(
        () => buildInstallationLogEventsFromOrder(installationOrder),
        [installationOrder]
    );

    const onPreviewInvoice = (t: InvoiceType) => {
        safeNavigate(`/agent/InvoiceDocument`, {
            state: {
                type: t,
                order: installationOrder, // pass the full order object used for the invoice
                imageUrlMap: undefined, // optional thumbs
                // logoUrl, serviceInfo, resolveImageSrc, ... if needed
                autoPrint: false, // set true if you want it to auto-open the print dialog
            },
        });
    };

    // tax related code below allowed to be deleted


    const coalesceDestination = (): Addresstax => {
        const a = installationAddress?.address_details as Addresstax | undefined;
        const f = (formik.values?.installation_address?.address_details) as Addresstax | undefined;
        return {
            addressLine1: a?.addressLine1 ?? f?.addressLine1 ?? "",
            city: a?.city ?? f?.city ?? "",
            state: a?.stateCode ?? a?.state ?? f?.state ?? f?.stateCode ?? "",
            zip: a?.zip ?? f?.zip ?? "",
            // country: a?.country ?? f?.country ?? "US",
            stateCode: a?.stateCode ?? f?.stateCode ?? "",
            latitude: a?.latitude ?? f?.latitude,
            longitude: a?.longitude ?? f?.longitude,
            // countryCode: a?.countryCode ?? f?.countryCode ?? "US",
        };
    };

    // --- Build what engine expects from Formik (fallback) ---
    const getSelectedFees = React.useCallback(() => {
        const raw = selectedSpecialFees.length
            ? selectedSpecialFees
            : Array.isArray(formik.values?.specialFees)
              ? formik.values.specialFees
              : [];
        return raw
            .map((f: any) => normalizeInstallationSelectedFee(f, allAvailableSpecialFees))
            .filter((f) => f.id !== "");
    }, [selectedSpecialFees, formik.values?.specialFees, allAvailableSpecialFees]);

    const keyForInstallationProduct = (p: { product_id: string; variant_id?: string }) => `${p.product_id}:${p.variant_id ?? ""}`;

    // discount_applies_to not in GET â€” infer: line_items[].discount > 0 â†’ product only; else order discount_amount â†’ installation only
    const getDiscountedBase = () => {
        const subAll = Number(installationCost || 0);
        const lineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
        const hasLineItemDiscount = lineItems.some(
            (li: any) => Number(li?.discount ?? li?.discount_amount ?? 0) > 0
        );
        const orderDiscountAmount = Number(installationOrder?.discount_amount ?? formik.values?.discount_amount ?? 0);
        const installationDiscount = !hasLineItemDiscount && orderDiscountAmount > 0 ? orderDiscountAmount : 0;
        return Math.max(0, subAll - installationDiscount);
    };

    // Build one list for TaxCloud (installation + special fees + line_items). Infer discount from data: line-item discount â†’ products only; order discount_amount â†’ installation only.
    const buildProductsMerged = (fees?: any[]): TaxProduct[] => {
        const items: TaxProduct[] = [];

        const lineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
        const orderDiscountAmount = Number(installationOrder?.discount_amount ?? formik.values?.discount_amount ?? 0);
        const hasLineItemDiscount = lineItems.some(
            (li: any) => Number(li?.discount ?? li?.discount_amount ?? 0) > 0
        );
        const installationDiscount = !hasLineItemDiscount && orderDiscountAmount > 0 ? orderDiscountAmount : 0;

        // âœ… Installation: only apply order-level discount when there is no discount inside line items
        if (dynamicTaxable) {
            const discountedInstallPrice = getDiscountedBase();
            if (discountedInstallPrice > 0) {
                items.push({ sku: "InstallationCost", price: discountedInstallPrice, quantity: 1, itemType: "service" });
            }
        }

        // âœ… Only include taxable special fees
        const feesToUse = fees ?? getSelectedFees();
        for (const fee of feesToUse) {
            const feeAmount = Number(fee?.amount || 0);
            if (feeAmount > 0 && fee?.taxable !== false) {
                items.push({ sku: fee?.name || "Special Fee", price: feeAmount, quantity: 1, itemType: "special_fee" });
            }
        }

        // âœ… Products: (total_price - discount) per line from order; taxable from item_tax_info; skip rotational + excluded source
        const EXCLUDED_SOURCE_ID = "000000000000000000000000";
        for (const li of lineItems) {
            const invSource = String(li?.inventory_source ?? "");
            const sourceId = li?.source_product_id != null ? String(li.source_product_id) : "";
            if (invSource === "rotational" || sourceId === EXCLUDED_SOURCE_ID) continue;
            if (!sourceId) continue;
            const qty = Math.max(0, Number(li?.quantity ?? 0));
            if (qty <= 0) continue;
            const totalPrice = Number(li?.total_price ?? 0) || Number(li?.unit_price ?? 0) * qty;
            const lineDiscount = Number(li?.discount ?? li?.discount_amount ?? 0);
            const discountedLineTotal = Math.max(0, totalPrice - lineDiscount);
            const priceToUse = qty > 0 ? discountedLineTotal / qty : 0;
            if (priceToUse <= 0) continue;
            const isTaxable =
                li?.item_tax_info && typeof (li.item_tax_info as any).taxable === "boolean"
                    ? (li.item_tax_info as any).taxable
                    : li?.is_new_purchase
                        ? (li?.is_taxable !== false)
                        : !!(li?.is_taxable);
            items.push({
                sku: String(li?.sku || li?.product_id || ""),
                price: Math.round(priceToUse * 100) / 100,
                quantity: qty,
                itemType: "default" as const,
                taxable: isTaxable,
            });
        }

        return items;
    };

    const getResolvedLineItem = React.useCallback(
        (p: { product_id: string; variant_id?: string }) => {
            const key = orderLineKey(p.product_id, p.variant_id);
            const fromFormik = ((formik.values as { resolved_line_items?: ResolvedInstallationLineItem[] })
                .resolved_line_items || []) as ResolvedInstallationLineItem[];
            const fromFormikLine = fromFormik.find(
                (li) => orderLineKey(li.product_id, li.variant_id) === key
            );
            if (fromFormikLine) return fromFormikLine;
            const fromRef = (lastResolvedInstallationRef.current?.line_items || []).find(
                (li) => orderLineKey(li.product_id, li.variant_id) === key
            );
            if (fromRef) return fromRef;
            return mapInstallationOrderLinesToResolved(installationOrder?.line_items).find(
                (li) => orderLineKey(li.product_id, li.variant_id) === key
            );
        },
        [
            (formik.values as { resolved_line_items?: ResolvedInstallationLineItem[] }).resolved_line_items,
            installationOrder?.line_items,
        ]
    );

    const unitsCost = React.useMemo(() => {
        const purchasedLines = (selectedProducts || []).filter((p) => isPurchasedInstallationLine(p));
        return computeInstallationUnitsCostFromChangedUnitPrice({
            products: purchasedLines.map((p) => ({
                product_id: p.product_id,
                variant_id: p.variant_id,
                quantity: p.quantity,
                unit_price: p.unit_price,
                changed_unit_price: p.changed_unit_price,
                inventory_type: p.inventory_type,
                inventory_source: (p as { inventory_source?: string }).inventory_source,
                Price: Number(p.changed_unit_price ?? p.unit_price ?? 0),
            })),
            manualUnitPriceMap: {},
            getResolvedLineItem,
            isCustomProduct: (product) =>
                String(product?.inventory_type || product?.inventory_source || "").toLowerCase() === "custom",
        });
    }, [selectedProducts, getResolvedLineItem]);

    const unitsPurchased = React.useMemo(() => {
        const lineItems = Array.isArray(installationOrder?.line_items) ? installationOrder.line_items : [];
        return lineItems.reduce((sum: number, li: any) => {
            const invSource = String(li?.inventory_source ?? "");
            const sourceId = li?.source_product_id != null ? String(li.source_product_id) : "";
            if (invSource === "rotational" || !sourceId || sourceId === "000000000000000000000000") return sum;
            const qty = Number(li?.quantity ?? 0);
            if (qty <= 0) return sum;
            return sum + qty;
        }, 0);
    }, [installationOrder?.line_items]);

    const [couponInput, setCouponInput] = useState("");
    const [couponResolveError, setCouponResolveError] = useState("");
    const [appliedVoucher, setAppliedVoucher] = useState<{ code: string; amount: number } | null>(null);

    // Discount amount: order-level, product discount, or sum of line_items discount (whichever is available)
    const getEffectiveDiscountAmount = () => {
        const formikCode = String(formik.values?.discount_code ?? "").trim();
        const formikAmount = Number(formik.values?.discount_amount ?? 0);
        if (!formikCode && formikAmount <= 0) {
            return 0;
        }

        const orderLevel = Number(installationOrder?.discount_amount ?? formik.values?.discount_amount ?? 0);
        const productLevel = Number((installationOrder as any)?.product_discount_amount ?? formik.values?.product_discount_amount ?? 0);
        const lineItemsSum = (installationOrder?.line_items ?? []).reduce((s: number, li: any) => {
            const d = Number(li?.discount ?? li?.discount_amount ?? li?.discount_on_total_quantity ?? li?.discount_on_total_quantity_amount ?? 0);
            return s + d;
        }, 0);
        const orderChargesDiscount = Number((installationOrder as any)?.order_charges?.[0]?.discount_amount ?? (installationOrder as any)?.order_charges?.[0]?.discount ?? 0);
        return orderLevel || productLevel || lineItemsSum || orderChargesDiscount;
    };

    const totalAmountNum =
        Number(installationCost || 0) +
        Number(unitsCost || 0) +
        Number(formik.values?.totals?.specialfee_subtotal || 0) +
        Number(formik.values?.totals?.installation_tax_amount || 0) +
        Number(formik.values?.totals?.specialfee_tax_amount || 0) +
        Number((formik.values?.totals as any)?.product_tax_amount || 0) -
        getEffectiveDiscountAmount();

    const TotalAmount = totalAmountNum.toFixed(2);
    const remaingamount = +(totalAmountNum - Number(totalPaid || 0)).toFixed(2);

    // --- Allow recompute to accept overrides so it never reads stale state ---
    type RecomputeOverride = {
        fees?: any[];
        destination?: any;
        discountCode?: string;
        action?: OrderResolveAction;
    };
    let finalCartId = "";
    if (ordernumber && installationOrder?.cart_id) {
        // if orderId contains "-", split and take the number after "-"
        const suffix = ordernumber.includes("-")
            ? ordernumber.split("-")[1]   // get part after "-"
            : "";                     // no suffix

        // append suffix to cart_id
        finalCartId = suffix ? `${installationOrder?.cart_id}-${suffix}` : installationOrder?.cart_id;
    }


    // âœ… Add ref to prevent overlapping recompute calls
    const isRecomputingRef = React.useRef(false);
    const prevFeesRef = React.useRef<string>("");

    const recompute = React.useCallback(async (override?: RecomputeOverride) => {
        if (!dynamicCostId) return false;

        if (isRecomputingRef.current) {
            safeConsole.log("⏭️ Skipping recompute - already in progress");
            return false;
        }

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
            pendingOverrideRef.current = null;
        }

        const supplierId = installationOrder?.seller_org_id || "";
        try {
            isRecomputingRef.current = true;
            setIsRecomputing(true);
            setCouponResolveError("");
            const fees = override?.fees ?? getSelectedFees();
            const agentDisplayName =
                `${formik.values.userFirstName || ""} ${formik.values.userLastName || ""}`.trim() ||
                userName ||
                "";

            const resolveDiscountCode = getInstallationResolveRootDiscountCode({
                discountCodeOverride: override?.discountCode,
                formikDiscountCode: formik.values.discount_code,
                orderDiscountCode: installationOrder?.discount_code,
                orderCouponCode: (installationOrder as any)?.coupon_code,
                orderLineItems: installationOrder?.line_items,
            });

            const resolveLineItems = buildInstallationEditResolveLineItems(
                installationOrder?.line_items,
                (selectedProducts || []).map((p) => ({
                    product_id: String(p.product_id),
                    variant_id: p.variant_id,
                    quantity: p.quantity,
                    name: p.name,
                    sku: p.sku,
                    unit_price:
                        Math.round(
                            (Number(p.unit_retail_price ?? p.unit_price ?? p.changed_unit_price ?? 0) +
                                Number.EPSILON) *
                                100
                        ) / 100,
                }))
            );

            const resolvePayload = buildInstallationResolvePayload({
                orderNumber: String(installationOrder?.order_number || "").trim(),
                cartId: String(finalCartId || installationOrder?.cart_id || ""),
                dynamicCostId,
                signageId: String(supplierId || selectedInstaller?.value || ""),
                sourceId: userId || "",
                customerId: userId || "",
                inventorySource: "agent",
                installationCost: Number(installationCost ?? formik.values.installation_cost ?? 0),
                installationTaxable: formik.values.install_taxable !== false,
                discountCode: resolveDiscountCode,
                paymentMethod: formik.values.payment_method || "card",
                userType: formik.values.userType,
                userName: agentDisplayName,
                userEmail: formik.values.userEmail,
                userPhone: formik.values.userPhone,
                customerFirstName: formik.values.userFirstName,
                customerLastName: formik.values.userLastName,
                customerEmail: formik.values.userEmail,
                customerPhone: formik.values.userPhone,
                agentId: userId || null,
                agentName: agentDisplayName,
                billingAddress: selectedBillingAddress as InstallationResolveAddress | null,
                installationAddress: installationAddress as InstallationResolveAddress | null,
                lineItems: resolveLineItems,
                specialFees: fees.map((f) => mapInstallationSpecialFeeForResolve(f, allAvailableSpecialFees)),
            });

            const resolveAction: OrderResolveAction = override?.action ?? "draft";

            const resolved = await postInstallationOrderResolve(token || "", {
                order_type: "installation",
                action: resolveAction,
                payload: resolvePayload,
            });

            if (!resolved || typeof resolved !== "object") {
                const allFeesSubtotal = fees.reduce((sum, f) => sum + Number(f.amount || 0), 0);
                formik.setFieldValue("totals.installation_subtotal", Number(installationCost) || 0, false);
                formik.setFieldValue("totals.installation_tax_amount", 0, false);
                formik.setFieldValue("totals.specialfee_subtotal", allFeesSubtotal, false);
                formik.setFieldValue("totals.specialfee_tax_amount", 0, false);
                formik.setFieldValue("totals.grand_total", (Number(installationCost) || 0) + allFeesSubtotal, false);
                formik.setFieldValue("specialFees", fees, false);
                return false;
            }

            lastResolvedInstallationRef.current = resolved;
            const applied = applyInstallationEditResolveResponse(
                resolved,
                formik,
                Number(installationCost) || 0,
                {
                    requestedDiscountCode: resolveDiscountCode,
                    feesFieldName: "specialFees",
                    existingFeeRows: fees,
                    specialFeeCatalog: allAvailableSpecialFees,
                }
            );
            setSelectedSpecialFees(applied.mergedFees);
            return true;
        } catch (e) {
            safeConsole.error("[OrderResolve] failed:", e);
            setCouponResolveError(
                String((e as { message?: string })?.message ?? "Failed to calculate pricing")
            );
            return false;
        } finally {
            isRecomputingRef.current = false;
            setIsRecomputing(false);
        }
    }, [
        token,
        userId,
        userName,
        installationOrder?.seller_org_id,
        installationOrder?.cart_id,
        installationOrder?.line_items,
        selectedProducts,
        selectedInstaller?.value,
        installationCost,
        dynamicCostId,
        formik,
        formik.values.installation_cost,
        formik.values.install_taxable,
        formik.values.install_tax_percentage,
        formik.values.discount_code,
        formik.values.discount_amount,
        installationAddress,
        selectedBillingAddress,
        getSelectedFees,
        finalCartId,
    ]);

    const ready = React.useMemo(
        () =>
            Boolean(
                isEdit &&
                (installationOrder?.seller_org_id || selectedInstaller?.value) &&
                installationAddress?.address_details &&
                Number.isFinite(Number(installationCost))
            ),
        [isEdit, installationOrder?.seller_org_id, selectedInstaller?.value, installationAddress?.address_details, installationCost]
    );

    const debounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
    const pendingOverrideRef = React.useRef<RecomputeOverride | null>(null);
    const recomputeRef = React.useRef(recompute);
    recomputeRef.current = recompute;

    const waitForRecomputeIdle = React.useCallback((maxMs = 10000) => {
        return new Promise<void>((resolve) => {
            const started = Date.now();
            const tick = () => {
                if (!isRecomputingRef.current || Date.now() - started > maxMs) {
                    resolve();
                    return;
                }
                window.setTimeout(tick, 50);
            };
            tick();
        });
    }, []);

    const applyDiscountCode = React.useCallback(
        async (rawCode: string) => {
            const code = String(rawCode || "").trim();
            if (!code) return;
            if (!dynamicCostId) {
                showError("Installation pricing is still loading. Please wait and try again.");
                return;
            }

            setCouponInput(code);
            formik.setFieldValue("discount_code", code, false);
            setCouponResolveError("");

            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
                debounceRef.current = null;
            }

            await waitForRecomputeIdle();

            const ok = await recomputeRef.current?.({ discountCode: code });
            const display = getResolvedDiscountDisplay(lastResolvedInstallationRef.current, code);

            if (display.code && display.amount > 0) {
                setAppliedVoucher({ code: display.code, amount: display.amount });
                setCouponInput(display.code);
                formik.setFieldValue("discount_code", display.code, false);
                formik.setFieldValue("discount_amount", display.amount, false);
                setZeroOrNegativeMsg("");
                setCouponResolveError("");
                return;
            }

            setAppliedVoucher(null);
            if (!ok) {
                setCouponResolveError((prev) => prev || "Discount could not be applied. Please try again.");
            } else {
                setCouponResolveError("This discount code could not be applied.");
            }
        },
        [dynamicCostId, formik, waitForRecomputeIdle]
    );

    const clearDiscountCode = React.useCallback(async () => {
        setAppliedVoucher(null);
        setCouponResolveError("");
        setCouponInput("");
        formik.setFieldValue("discount_code", "", false);
        formik.setFieldValue("discount_amount", 0, false);
        formik.setFieldValue("product_discount_amount", 0, false);
        setZeroOrNegativeMsg("");

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }

        await waitForRecomputeIdle();
        await recomputeRef.current?.({ discountCode: "" });
    }, [formik, waitForRecomputeIdle]);

    const discountDisplay = React.useMemo(
        () =>
            getOrderDiscountFieldDisplay({
                formikCode: formik.values.discount_code,
                formikAmount: formik.values.discount_amount,
                couponInput,
                appliedVoucher,
                resolved: lastResolvedInstallationRef.current,
            }),
        [
            appliedVoucher,
            formik.values.discount_code,
            formik.values.discount_amount,
            couponInput,
        ]
    );

    const triggerRecomputeWith = React.useCallback((override?: RecomputeOverride) => {
        // âœ… Don't schedule if recompute is already running
        if (isRecomputingRef.current) {
            safeConsole.log("â¸ï¸ Recompute in progress, skipping debounced call");
            return;
        }

        pendingOverrideRef.current = override || null;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            // âœ… Double-check before calling (in case state changed during debounce)
            if (!isRecomputingRef.current) {
                const ov = pendingOverrideRef.current;
                pendingOverrideRef.current = null;
                recompute(ov || undefined);
            }
        }, 300);
    }, [recompute]);

    triggerRecomputeWithRef.current = triggerRecomputeWith;

    // âœ… Trigger recompute when installation cost changes (e.g., when map marker is dragged)
    const prevInstallCostRef = React.useRef<number | null>(null);
    React.useEffect(() => {
        if (!ready) return;

        // âœ… Only trigger if cost actually changed
        if (prevInstallCostRef.current === installationCost) return;

        // Skip first render
        if (prevInstallCostRef.current === null) {
            prevInstallCostRef.current = installationCost;
            return;
        }

        prevInstallCostRef.current = installationCost;
        // console.log("ðŸ”„ Installation cost changed, triggering tax recalculation");
        triggerRecomputeWith();
    }, [installationCost, ready, triggerRecomputeWith]);

    const installationAddressSig = React.useMemo(() => {
        const d = installationAddress?.address_details;
        if (!d) return "";
        return [
            d.addressLine1,
            d.city,
            d.state,
            d.stateCode,
            d.zip,
            d.latitude,
            d.longitude,
        ].join("|");
    }, [installationAddress?.address_details]);

    const prevInstallationAddressSigRef = React.useRef<string | null>(null);

    React.useEffect(() => {
        if (!isEdit || !ready || !installationAddressSig) return;

        if (prevInstallationAddressSigRef.current === null) {
            prevInstallationAddressSigRef.current = installationAddressSig;
            return;
        }

        if (prevInstallationAddressSigRef.current === installationAddressSig) return;

        prevInstallationAddressSigRef.current = installationAddressSig;
        triggerRecomputeWith();
    }, [installationAddressSig, isEdit, ready, triggerRecomputeWith]);

    React.useEffect(() => () => { if (debounceRef.current) clearTimeout(debounceRef.current); }, []);

    // âœ… Fetch active tax type on mount
    useEffect(() => {
        (async () => {
            try {
                if (!token || !installationOrder?.seller_org_id) return;
                const t = await getActiveTaxType(token, installationOrder.seller_org_id);
                setTaxType(t === "taxcloud" ? "taxcloud" : t === "manual" ? "manual" : "unknown");
                // console.log("[TAX] Active tax type:", t);
            } catch (e) {
                safeConsole.warn("[TAX] getActiveTaxType failed:", e);
                setTaxType("unknown");
            }
        })();
    }, [token, installationOrder?.seller_org_id]);

    const normalizedPaymentStatus = String(installationOrder?.payment_status || "").trim().toLowerCase();
    const isOrderPaid = normalizedPaymentStatus == "paid";
    const normalizedTaxStatus = String(installationOrder?.tax_status || "").trim().toLowerCase();
    const shouldAutoFinalizeTax =
        isOrderPaid &&
        normalizedTaxStatus === "draft" || "";

    // âœ… Auto-finalize TaxCloud order when payment_status becomes "Paid"
    useEffect(() => {
        const shouldFinalize =
            taxType === "taxcloud" &&
            dynamicCostId &&
            finalCartId &&
            installationOrder?.order_number &&
            !taxCloudFinalized;
        // console.log("[TaxCloud] Auto-finalize check:", {
        //     taxType,
        //     cartId: installationOrder?.cart_id,
        //     orderNumber: installationOrder?.order_number,
        //     taxStatus: installationOrder?.tax_status,
        //     paymentStatus: installationOrder?.payment_status,
        //     taxCloudFinalized,
        // }); 
        if (!shouldFinalize) return;
        // console.log("[TaxCloud] Conditions met for auto-finalization.");
        if (!shouldAutoFinalizeTax) return;
        // console.log("[TaxCloud] Auto-finalizing order...");

        let cancelled = false;
        (async () => {
            try {
                const resolvedOk = await recomputeRef.current({ action: "complete" });
                if (cancelled || !resolvedOk) return;

                const resolved = lastResolvedInstallationRef.current;
                if (!resolved) return;

                const patchBody = buildInstallationPatchFromResolved(resolved, {
                    version: installationOrder?.version,
                    installationCost: Number(
                        installationCost ??
                            formik.values.installation_cost ??
                            installationOrder?.installation_cost ??
                            0
                    ),
                    existingLineItems: installationOrder?.line_items ?? [],
                    taxStatus: "complete",
                });

                const patchRes = await fetch(
                    `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
                    {
                        method: "PATCH",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(patchBody),
                    }
                );

                if (patchRes.ok) {
                    setTaxCloudFinalized(true);
                    showSuccess("TaxCloud order finalized successfully!");
                    await fetchOrderDetails();
                } else {
                    const errorText = await patchRes.text().catch(() => "");
                    safeConsole.error("[TaxCloud] Failed to update tax_status:", errorText);
                }
            } catch (e: any) {
                if (!cancelled) {
                    safeConsole.error("[TaxCloud] Auto-finalize failed:", e);
                    safeConsole.warn("TaxCloud finalization error (non-critical):", e?.message);
                }
            }
        })();

        return () => { cancelled = true; };
    }, [
        taxType,
        dynamicCostId,
        ordernumber,
        finalCartId,
        installationOrder?.payment_status,
        installationOrder?.cart_id,
        installationOrder?.order_number,
        installationOrder?.tax_status,
        installationOrder?.version,
        taxCloudFinalized,
        token,
        installationId,
        fetchOrderDetails,
        shouldAutoFinalizeTax,
    ]);

    useEffect(() => {
        (async () => {
            if (!token || !installationOrder) return;

            const orderdata = (await GetVersionOrdernumber(
                token,
                installationOrder.order_number,
                installationOrder?.order_type || "installation"
            )) || null;
            const orderId = (orderdata as any)?.full_number || (orderdata as any)?.order_number || "";
            setOrderNumber(orderId);
        })();
    }, [token, installationOrder]);

    const recalcInstallationTaxes = React.useCallback(
        async (forceType?: "manual" | "taxcloud", options?: { allowRefund?: boolean }) => {
            try {
                await recompute();
            } catch (err) {
                safeConsole.error("[INSTALL:TAX] recompute before refund failed", err);
            }

            if (!options?.allowRefund) return false;
            if (!token || !installationOrder?.order_number) return false;
            if (installationOrder?.tax_status !== "complete") return false;
            if (forceType !== "taxcloud") return false;

            try {
                const orderdata = (await GetVersionOrdernumber(
                    token,
                    installationOrder.order_number,
                    installationOrder?.order_type || "installation"
                )) || null;
                const order_number = (orderdata as any)?.full_number || (orderdata as any)?.order_number || "";
                if (!order_number) throw new Error("Missing order number for refund");
                const success = await requestInstallationTaxRefund(token, order_number || "");
                if (!success) throw new Error("TaxCloud refund failed");
                return true;
            } catch (err) {
                safeConsole.error("[INSTALL:TAX] refund failed:", err);
                showError("Failed to request TaxCloud refund.");
                return false;
            }
        },
        [installationOrder?.order_number, installationOrder?.tax_status, recompute, token]
    );

    React.useEffect(() => {
        installationTaxRef.current = { recalculate: recalcInstallationTaxes };
    }, [recalcInstallationTaxes]);

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <div className="content container">
            {
                <style>{`
                    .custom-btn {
                          font-size: 14px;
                          font-weight: 600;
                      }
                      .custom-btn:hover {
                          background-color: #155dfc;
                          color: #fff;
                          font-size: 14px;
                          font-weight: 600;
                      }
        `}</style>
            }
            <div className="page-container ps-0">
                <h3 className="m-0 text-center fw-bold addheaders ps-1">
                    Installation Job #{installationOrder?.order_number} - {type === "View" ? "View" : "Edit"}
                </h3>
            </div>
            <div className="mb-4">
                <div className="align-items-center col-lg-12 d-flex flex-wrap justify-content-end justify-content-lg-between os-card">
                    {Viewmode && (
                        <div className="dropdown p-2 d-flex d-lg-none">
                            <button
                                className="btn btn-outline-secondary dropdown-toggle btn-sm br-8 table-cells custom-btn px-3"
                                type="button"
                                id="orderActionsDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Actions
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="orderActionsDropdown">

                                {installationOrder?.status === 100 && (
                                    <Link to={`/agent/jobs/viewInstallation/${installationOrder._id}`} state={{ type: "Edit" }} className="dropdown-item text-primary table-cells">
                                        <i className="ri-pencil-fill me-2"></i>Edit
                                    </Link>
                                )}
                                <Link to={""} className="dropdown-item text-primary table-cells">
                                    <i className="ri-mail-send-line me-2"></i>Email
                                </Link>
                                {(installationOrder?.status <= 100) && (
                                    <button className="dropdown-item text-danger table-cells" style={{ paddingLeft: 12 }} onClick={() => handleInstallationStatus(600)}>
                                        <i className="mdi mdi-archive-remove-outline me-2"></i>Cancel Job
                                    </button>
                                )}
                                {/* {installationOrder?.status === 200 && (
                      <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                        Click to Schedule
                      </button>
                    )}
      
                    {installationOrder?.status === 300 && (
                      <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                        Click to Re-Schedule
                      </button>
                    )} */}
                            </ul>
                        </div>
                    )}
                    <div className="d-flex flex-grow-1 tracker-wrapper">
                        <InstallationStatusTracker type="installation" status={installationOrder?.status} paymentStatus={installationOrder?.payment_status} className="mb-3 mb-lg-2 w-100" />
                    </div>

                    {Viewmode && (
                        <div className="dropdown p-2 d-none d-lg-block">
                            <button
                                className="btn btn-outline-secondary dropdown-toggle btn-sm br-8 table-cells custom-btn px-3"
                                type="button"
                                id="orderActionsDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Actions
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="orderActionsDropdown">

                                {installationOrder?.status === 100 && (
                                    <Link to={`/agent/jobs/viewInstallation/${installationOrder._id}`} state={{ type: "Edit" }} className="dropdown-item text-primary table-cells">
                                        <i className="ri-pencil-fill me-2"></i>Edit
                                    </Link>
                                )}
                                <Link to={""} className="dropdown-item text-primary table-cells">
                                    <i className="ri-mail-send-line me-2"></i>Email
                                </Link>

                                {
                                 Number(installationOrder?.status ?? 0) >= 300 && (
                                        // <li>
                                        //   <button
                                        //     type="button"
                                        //     className="dropdown-item"
                                        //     disabled={orderSummarySending}
                                        //     onClick={() => void handleInstallationOrderSummaryClick()}
                                        //   >
                                        //     <i className="bi bi-file-earmark-text me-2" />
                                        //     {orderSummarySending ? "Sendingâ€¦" : "Order Summary"}
                                        //   </button>
                                        // </li>
                                        <li>
                                            <button className="dropdown-item" onClick={() => onPreviewInvoice("installation")}>
                                                <i className="bi bi-eye me-2" /> Preview Invoice
                                            </button>
                                        </li>
                                    )}
                                {(installationOrder?.status <= 100) && (
                                    <button className="dropdown-item text-danger table-cells" style={{ paddingLeft: 12 }} onClick={() => handleInstallationStatus(600)}>
                                        <i className="mdi mdi-archive-remove-outline me-2"></i>Cancel Job
                                    </button>
                                )}
                                {/* {installationOrder?.status === 200 && (
                      <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                        Click to Schedule
                      </button>
                    )}
      
                    {installationOrder?.status === 300 && (
                      <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                        Click to Re-Schedule
                      </button>
                    )} */}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
            <div className="">
                <div className="">
                    {/* Hidden Invoice for PDF generation */}
                    {/* <div style={{ position: "absolute", left: -99999, top: 0 }}>
                        <div ref={invoiceRef}>
                            <OrderInvoice
                                order={normalizeInstallationToSalesOrder(installationOrder)}
                                customer={null as any}
                                leftAddressLabel="Bill to:"
                                rightAddressLabel="Install to:"
                            />
                        </div>
                    </div> */}
                    <form onSubmit={formik.handleSubmit} className="me-2 me-lg-0">
                        <div className="row col-lg-12 card-body shadow-lg pb-4 mb-4 ms-0 p-3">
                            <div className="mb-3">
                                <SectionHeader title="Customer Information" icon="ri-user-3-line" color="#155dfc" size="md" divider />
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="userFirstName" className="form-label">First Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="userFirstName"
                                    name="userFirstName"
                                    placeholder="Enter first name"
                                    value={formik.values.userFirstName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                                {formik.touched.userFirstName && formik.errors.userFirstName && (
                                    <div className="text-danger">{formik.errors.userFirstName}</div>
                                )}
                            </div>

                            {/* Last Name */}
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="userLastName" className="form-label">Last Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="userLastName"
                                    name="userLastName"
                                    placeholder="Enter last name"
                                    value={formik.values.userLastName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                                {formik.touched.userLastName && formik.errors.userLastName && (
                                    <div className="text-danger">{formik.errors.userLastName}</div>
                                )}
                            </div>

                            <div className="col-lg-3 mb-3">
                                <label htmlFor="userEmail" className="form-label table-headers">Email <span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className={`form-control table-cells ${(formik.submitCount > 0 || formik.touched.userEmail) && formik.errors.userEmail ? "is-invalid" : ""}`}
                                    id="userEmail"
                                    name="userEmail"
                                    placeholder="Enter email"
                                    value={formik.values.userEmail}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={readOnly}
                                />
                                {(formik.submitCount > 0 || formik.touched.userEmail) && formik.errors.userEmail && (
                                    <div className="invalid-feedback d-block">{String(formik.errors.userEmail)}</div>
                                )}
                            </div>

                            <div className="col-lg-3 mb-3">
                                <label htmlFor="userPhone" className="form-label  table-headers">
                                    Phone <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className={`form-control table-cells ${(formik.submitCount > 0 || formik.touched.userPhone) && formik.errors.userPhone ? "is-invalid" : ""}`}
                                    id="userPhone"
                                    name="userPhone"
                                    placeholder="Enter phone"
                                    value={formik.values.userPhone}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={readOnly}
                                />
                                {(formik.submitCount > 0 || formik.touched.userPhone) && formik.errors.userPhone && (
                                    <div className="invalid-feedback d-block">{String(formik.errors.userPhone)}</div>
                                )}
                            </div>
                        </div>
                        <div className="d-block d-lg-flex gap-3">
                            <div className="col-lg-8">
                                <div className="row col-lg-12 card-body shadow-lg mb-4 ms-0 p-3">
                                    <div className="mb-3">
                                        <SectionHeader title="Schedule & Assignment" icon="ri-calendar-line" color="#00a63e" size="md" divider />
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label className="form-label table-cells">
                                            Selected Vendor <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            // className="form-control"
                                            id="installer"
                                            name="installer"
                                            options={installerOptions}
                                            value={installerOptions?.find((option) => option.value === formik.values.installer)}
                                            onChange={(selected) => {
                                                formik.setFieldValue("installer", selected?.value || "");
                                                // fetchLinkedProducts(selected?.value || "");
                                                setSelectedInstaller(selected);

                                                const supplierId = selected?.value ?? "";
                                            }}
                                            components={{ DropdownIndicator }}
                                            styles={customSelectStyles}
                                            onBlur={() => formik.setFieldTouched("installer", true)}
                                            isDisabled
                                            classNamePrefix="rs"
                                        />
                                        {(formik.submitCount > 0 || formik.touched.installer) && formik.errors.installer && (
                                            <div className="text-danger">{String(formik.errors.installer)}</div>
                                        )}

                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label className="form-label table-cells">
                                            Select Date <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className={`form-control ${formik.submitCount > 0 &&
                                                formik.errors.scheduled_date
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            id="scheduled_date"
                                            name="scheduled_date"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.scheduled_date}
                                            disabled={readOnly}
                                        />
                                        {formik.submitCount > 0 &&
                                            typeof formik.errors.scheduled_date === "string" && (
                                                <div className="text-danger d-block">{formik.errors.scheduled_date}</div>
                                            )}

                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label className="form-label table-cells">
                                            Priority
                                        </label>
                                        <Select
                                            id="priority"
                                            name="priority"
                                            options={priorityOptions}
                                            value={priorityOptions.find((option) => option.value === formik.values.priority) || null}
                                            onChange={(option) =>
                                                formik.setFieldValue("priority", option?.value || "")
                                            }
                                            onBlur={() => formik.setFieldTouched("priority", true)}
                                            isDisabled={readOnly}
                                            components={{ DropdownIndicator }}
                                            styles={customSelectStyles}
                                            classNamePrefix="rs"
                                        />
                                        {(formik.submitCount > 0 || formik.touched.priority) && formik.errors.priority && (
                                            <div className="text-danger">{String(formik.errors.priority)}</div>
                                        )}
                                    </div>
                                </div>
                                {String(
                                    installationOrder?.project_id ||
                                    installationOrder?.project?.id ||
                                    ""
                                ).trim() && hasApprovedMessage ? (
                                    <div className="row col-lg-12 mb-3 ms-0 p-0">
                                        {approvedProofCards.map((card) => (
                                            <CompactApprovedProofCard
                                                key={`approved-proof-v-${card.version}`}
                                                version={card.version}
                                                files={card.files}
                                                approvedBy={card.approvedByName}
                                                approvedAt={card.approvedAtLabel}
                                                footerBy={card.assignedToName}
                                                variant="installation"
                                                billingAddress={card.billingAddress}
                                                installationAddress={card.installationAddress}
                                                shippingName={card.shippingName}
                                                shippingDesc={card.shippingDesc}
                                                shippingAmountLabel={card.shippingAmountLabel}
                                                onDownloadByFileId={(fileId, fileName) => {
                                                    void downloadWorkDriveFile(fileId, fileName);
                                                }}
                                            />
                                        ))}
                                    </div>
                                ) : null}
                                <div className="row col-lg-12 mb-4 card-body shadow-lg mb-4 ms-0 pb-3 p-3">
                                    <div className="align-items-center d-block d-lg-flex justify-content-between mb-3">
                                        {/* Left side: Address Information with purple icon */}
                                        <SectionHeader title="Address Information" icon="ri-map-pin-line" color="#e7000b" size="md" divider className="mb-3 mb-lg-0" />

                                        {/* Right side: Gate Code with functionality */}
                                        <div className="d-flex align-items-center gap-3">
                                            <label className="table-cells mb-0">Gate Code</label>
                                            <div className="d-flex align-items-center gap-2">
                                                <input
                                                    type="text"
                                                    id="gatecode"
                                                    name="gatecode"
                                                    className="form-control"
                                                    style={{
                                                        width: '140px',
                                                        backgroundColor: formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500 ? '#ffffff' : '#f8f9fa',
                                                        color: formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500 ? '#495057' : '#6c757d',
                                                        cursor: formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 500 ? 'text' : 'pointer'
                                                    }}
                                                    value={formik.values.gatecode}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Enter Gate Code"
                                                    readOnly={!formik.values.gateCodeEnabled || (installationOrder?.status ?? 0) >= 600}
                                                    disabled={(installationOrder?.status ?? 0) >= 600}
                                                    onClick={() => {
                                                        if (!formik.values.gateCodeEnabled && (installationOrder?.status ?? 0) < 700) {
                                                            formik.setFieldValue("gateCodeEnabled", true);
                                                        }
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary table-addbutton btn-sm br-8"
                                                    disabled={!formik.values.gateCodeEnabled || (installationOrder?.status ?? 0) >= 600}
                                                    onClick={async () => {
                                                        // Save gate code and disable the field again
                                                        await handleSaveGateCode();
                                                        formik.setFieldValue("gateCodeEnabled", false);
                                                    }}
                                                >
                                                    <i className="ri-save-fill fs-16"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="billingAddressId"
                                                        className="form-label table-headers"
                                                    >
                                                        Billing Address <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        // className="form-control"
                                                        id="billingAddress"
                                                        name="billingAddress"
                                                        options={addressOptions}
                                                        value={addressOptions?.find((option) => option.value === formik.values.billingAddressId) || null}
                                                        onChange={(selected) => {
                                                            // console.log("Selected Billing Address:", selected); // Debugging log
                                                            formik.setFieldValue("billingAddressId", selected?.value); // Ensure it's set
                                                            setSelectedBillingAddress(selected);

                                                            // If billing address is changed in edit mode, set both_address_same to false
                                                            if (isEdit && selected) {
                                                                formik.setFieldValue("isSameAsBilling", false);
                                                            }
                                                        }}
                                                        components={{ DropdownIndicator }}
                                                        styles={customSelectStyles}
                                                        classNamePrefix="rs"
                                                        onBlur={() => formik.setFieldTouched("billingAddressId", true)}
                                                        isDisabled={installationOrder?.status > 100 || readOnly}
                                                    />


                                                    {(formik.submitCount > 0 || formik.touched.billingAddressId) && formik.errors.billingAddressId && (
                                                        <div className="text-danger mt-1">
                                                            {String(formik.errors.billingAddressId)}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* {formik.values.isSameAsBilling === true ? null : ( */}
                                            <div className="col-lg-6 mb-3">
                                                <div className="">
                                                    <label
                                                        htmlFor="installationAddressId"
                                                        className="form-label table-cells"
                                                    >
                                                        Installation Address <span className="text-danger">*</span>
                                                    </label>
                                                    {isEdit && (installationOrder?.status === 100) ? (
                                                        <AddressAutocomplete
                                                            id="installationAddressId"
                                                            name="installationAddressId"
                                                            value={formik.values.installationAddressId}
                                                            onChange={(v) => {
                                                                formik.setFieldValue("installationAddressId", v);
                                                                formik.setFieldTouched("installationAddressId", true, false);

                                                                if (!String(v || "").trim()) {
                                                                    setInstallationAddress(undefined);
                                                                }
                                                            }}
                                                            onSelect={(picked) => {
                                                                const installation_address = `${picked.addressLine1}, ${picked.city}, ${picked.state}, ${picked.zipcode}`;

                                                                const addressDetails: Address = {
                                                                    _id: "",
                                                                    label: installation_address,
                                                                    addressLine1: picked.addressLine1,
                                                                    addressLine2: "",
                                                                    country: picked.country,
                                                                    county: picked.city,
                                                                    city: picked.city,
                                                                    state: picked.state,
                                                                    zip: picked.zipcode,
                                                                    cityCode: picked.cityCode,
                                                                    stateCode: picked.stateCode,
                                                                    countryCode: picked.countryCode,
                                                                    latitude: picked.latitude,
                                                                    longitude: picked.longitude,
                                                                    phone: "",
                                                                };

                                                                const newAddresses: Addresses = {
                                                                    _id: "",
                                                                    user_id: "",
                                                                    user_type: "",
                                                                    label: installation_address,
                                                                    first_name: "",
                                                                    last_name: "",
                                                                    company: "",
                                                                    default_address: false,
                                                                    address_details: addressDetails,
                                                                    created_by: {
                                                                        id: userId || "",
                                                                        name: userName || "",
                                                                    },
                                                                    updated_by: {
                                                                        id: userId || "",
                                                                        name: userName || "",
                                                                    },
                                                                };

                                                                setInstallationAddress(newAddresses);
                                                                formik.setFieldValue('installationAddressId', installation_address);
                                                                formik.setFieldTouched("installationAddressId", true, false);
                                                                formik.setFieldValue("isSameAsBilling", false);
                                                                triggerRecomputeWith();
                                                            }}
                                                            className={`form-control table-cells ${(formik.submitCount > 0 || formik.touched.installationAddressId) && formik.errors.installationAddressId ? "is-invalid" : ""}`}
                                                            placeholder="Enter installation address"
                                                            error={(formik.submitCount > 0 || formik.touched.installationAddressId) && formik.errors.installationAddressId ? (formik.errors.installationAddressId as string) : undefined}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="installationAddressId"
                                                            name="installationAddressId"
                                                            value={formatInstallationAddressForDisplay(
                                                                installationAddress || installationOrder?.installation_details?.installation_address
                                                            )}
                                                            readOnly
                                                        />
                                                    )}

                                                </div>
                                            </div>
                                            {/* )} */}
                                            {(installationOrder?.status === 100 && isEdit) &&
                                                <div className="col-lg-12 d-flex justify-content-end pe-4 mb-3" style={{ marginTop: "0px !important" }}>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm rounded-pill d-inline-flex align-items-center gap-2 shadow-sm ${isMarkerDraggable ? "btn-success" : "btn-outline-primary"}`}
                                                        title={`${isMarkerDraggable ? "Disable map edit" : "Enable map edit"}`}
                                                        onClick={() => {
                                                            const newValue = !isMarkerDraggable;
                                                            setIsMarkerDraggable(newValue);
                                                            showSuccess(
                                                                newValue
                                                                    ? "You can now move the marker on the map."
                                                                    : "Marker dragging disabled."
                                                            );
                                                        }}
                                                    >
                                                        <i className="ri-map-2-line fs-17"></i>
                                                        <i className="ri-edit-2-line fs-17"></i>
                                                        <span className="small fw-semibold">{isMarkerDraggable ? "Editing" : "Edit Map"}</span>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div style={mapContainerStyle}>
                                            <GoogleMap
                                                mapContainerStyle={mapContainerStyle}
                                                zoom={10}
                                                center={selectedLocation || center}
                                            // onClick={handleMapClick}
                                            >
                                                {selectedLocation && <Marker
                                                    position={selectedLocation}
                                                    draggable={isMarkerDraggable}
                                                    onDragEnd={handleMarkerDragEnd}
                                                />
                                                }
                                            </GoogleMap>
                                        </div>
                                        {formik.touched.location && formik.errors.location && (
                                            <div className="text-danger">{formik.errors.location}</div>
                                        )}
                                    </div>
                                </div>
                                {/* Post Type & Sign Configuration — view: filled slots only; edit: all slots like Add Installation */}
                                {installationOrder?.installation_post?.post_type_id ? (
                                    Viewmode ? (
                                        <PostTypeSignConfiguration
                                            type="view"
                                            vendorId={pickerSignageCompanyId}
                                            token={token || ""}
                                            viewModePostTypeId={installationOrder?.installation_post?.post_type_id}
                                            viewModeVendorId={pickerSignageCompanyId}
                                            viewModeInstallationPost={installationOrder?.installation_post ?? undefined}
                                            viewModeLineItems={viewModeLineItemsForPost}
                                        />
                                    ) : (
                                        <PostTypeSignConfiguration
                                            type="edit"
                                            vendorId={pickerSignageCompanyId}
                                            token={token || ""}
                                            postTypeOrderContext={postTypeOrderContext}
                                            pickerUserType={pickerUserType}
                                            pickerUserId={pickerUserId}
                                            pickerEndUserId={pickerEndUserId}
                                            pickerSignageCompanyId={pickerSignageCompanyId}
                                            viewModePostTypeId={installationOrder?.installation_post?.post_type_id}
                                            viewModeVendorId={pickerSignageCompanyId}
                                            viewModeInstallationPost={installationOrder?.installation_post ?? undefined}
                                            editModeHydrationProducts={editModeHydrationProducts}
                                            selectedProductIds={selectedProducts.map((p) => String(p.product_id ?? "")).filter(Boolean)}
                                            selectedStockLines={selectedStockLines}
                                            baselineStockLines={baselineStockLines}
                                            accessoryCount={selectedProducts
                                                .filter((p) => p.is_accessory || p.is_accessories)
                                                .reduce((sum, p) => sum + (Number(p.quantity) || 0), 0)}
                                            onClearSlotReady={(api) => { postTypeConfigRef.current = api; }}
                                            onInstallationPostChange={setInstallationPost}
                                            onSlotDuplicateProduct={() =>
                                                showError("This product is already selected. You cannot assign the same product to multiple slots.")
                                            }
                                            onSlotRemoved={(slotKey, slotId) => {
                                                setSelectedProducts((prev) =>
                                                    prev.filter((p) => !isProductInSlot(p, slotKey, slotId))
                                                );
                                            }}
                                            onSlotProductSelect={handleSlotProductSelect}
                                            onCustomItemAdd={
                                                customProductSettingEnabled ? handleCustomItemAdd : undefined
                                            }
                                        />
                                    )
                                ) : null}
                                <div className="row col-lg-12 mb-5 card-body shadow-lg mb-3 ms-0 p-3">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="d-flex">
                                            <span
                                                aria-hidden="true"
                                                className="image-icons"
                                                style={{
                                                    backgroundColor: "#9810fa",
                                                    WebkitMaskImage: `url(${ProductSelection})`,
                                                    maskImage: `url(${ProductSelection})`,
                                                }}
                                            />
                                            <SectionHeader title="Product Selection" icon="" variant="success" size="md" divider />
                                        </div>
                                        {!Viewmode && !isEdit && (
                                            <button type="button" className="btn btn-primary table-addbutton" onClick={() => setPickerOpen(true)} disabled={(installationOrder?.status ?? 0) > 100}>
                                                <i className="ri-add-line me-1"></i> Add Product
                                            </button>
                                        )}
                                    </div>
                                    <div className="col-lg-12">
                                        {(() => {
                                            const visibleProducts = selectedProducts
                                                ?.map((item, index) => ({ item, index }))
                                                ?.filter(({ item }) => item.inventory_type !== "rotational" && item.inventory_type !== "") || [];
                                            const inventoryProducts = visibleProducts.filter(({ item }) => !isPurchasedInstallationLine(item));
                                            const purchasedProducts = visibleProducts.filter(({ item }) => isPurchasedInstallationLine(item));
                                            const renderProductCard = (item: FlattenedProduct & { product_name?: string }, index: number, displayIndex: number, isPurchasedLine: boolean) => {
                                                const priceKey = keyForInstallationProduct(item);
                                                const resolvedLine = isPurchasedLine ? getResolvedLineItem(item) : undefined;
                                                const displayUnitCost = isPurchasedLine
                                                    ? getInstallationLineChangedUnitCostTotal(priceKey, item, {}, resolvedLine)
                                                    : 0;
                                                const rowDiscount = isPurchasedLine
                                                    ? getInstallationLineDiscountDisplay(priceKey, item, {}, resolvedLine)
                                                    : 0;
                                                return (
                                                <div key={item.product_id} className="mb-3 p-3 rounded-3 border shadow-sm bg-gray-50">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <h6 className="mm-2">Product #{displayIndex}</h6>
                                                        {!Viewmode && !isEdit && (
                                                            <button type="button" className="btn btn-link text-danger p-0" title="Remove" onClick={() => removeRow(item.product_id)} disabled={(installationOrder?.status ?? 0) > 100}>
                                                                <i className="ri-delete-bin-line fs-5"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="row g-3">
                                                        <div className="col-lg-12 pt-3 row">
                                                            <div className="col-lg-6 mb-3 mb-lg-0">
                                                                <label className="table-cells">Product Name</label>
                                                                <input type="text" className="form-control" value={item.name || item.product_name || ""} readOnly disabled />
                                                            </div>

                                                            <div className="col-lg-3 mb-3 mb-lg-0">
                                                                <label className="table-cells">SKU/Product Code</label>
                                                                <input type="text" className="form-control" value={displayInstallationSku(item)} readOnly disabled />
                                                            </div>

                                                            {isEdit && (
                                                                <div className="col-lg-3 mb-3 mb-lg-0">
                                                                    <label className="table-cells">Available Qty</label>
                                                                    <input type="number" className="form-control" value={Number(item.availableqty ?? 0)} readOnly disabled />
                                                                </div>
                                                            )}

                                                            <div className={`col-lg-3 mb-3 mb-lg-0 ${isEdit ? "mt-3" : ""}`}>
                                                                <label className="table-cells">Quantity</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    min={0}
                                                                    placeholder="0"
                                                                    value={item.quantity || ''}
                                                                    onChange={(e) => {
                                                                        const rawValue = e.target.value;
                                                                        const qty = rawValue === '' ? '' : Number(rawValue);
                                                                        setSelectedProducts((prev) =>
                                                                            prev.map((p) =>
                                                                                p.product_id === item.product_id ? { ...p, quantity: qty } : p
                                                                            )
                                                                        );
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        const currentValue = e.target.value;
                                                                        if (currentValue === '' || Number(currentValue) <= 0) {
                                                                            setSelectedProducts((prev) =>
                                                                                prev.map((p) =>
                                                                                    p.product_id === item.product_id ? { ...p, quantity: 1 } : p
                                                                                )
                                                                            );
                                                                        }
                                                                    }}
                                                                    onWheel={(e) => e.currentTarget.blur()}
                                                                    disabled
                                                                />
                                                            </div>

                                                            <div className={`col-lg-3 mb-3 mb-lg-0 ${isEdit ? "mt-3" : "mt-3"}`}>
                                                                <label className="table-cells">Unit Cost</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control text-center"
                                                                    value={isPurchasedLine ? displayUnitCost.toFixed(2) : "-"}
                                                                    readOnly
                                                                    disabled
                                                                />
                                                            </div>

                                                            {isPurchasedLine && (
                                                                <div className={`col-lg-3 mb-3 mb-lg-0 ${isEdit ? "mt-3" : "mt-3"}`}>
                                                                    <label className="table-cells">Discount</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-center"
                                                                        value={formatLineDiscountAmount(rowDiscount)}
                                                                        readOnly
                                                                        disabled
                                                                        style={rowDiscount > 0 ? { color: "#00a63e" } : undefined}
                                                                    />
                                                                </div>
                                                            )}

                                                            <div className="col-lg-6 mb-3 mb-lg-0 mt-3">
                                                                <label className="table-cells">Production Status</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={(item.productionStatus || item.product_current_status || item.current_status || "--").toString().replace(/_/g, " ")}
                                                                    readOnly
                                                                    disabled
                                                                />
                                                            </div>

                                                            <div className="col-lg-3 mb-3 mb-lg-0 mt-3">
                                                                <label className="table-cells">Product Location</label>
                                                                <div className="d-flex align-items-center gap-2 col-12">
                                                                    <StatusBadge status={(item.product_location_status || item.product_current_status)?.replace(/_/g, " ") || "-"} />
                                                                    {/* <Link className="border-0 p-0" to={item.inventory_type === "agent" ? "/realtor/agentInventory" : "/realtor/officeInventory"}>
                                                                        <i className="ri-link-m fs-5" />
                                                                    </Link> */}
                                                                </div>
                                                            </div>

                                                            {/* <div className={`mb-3 mb-lg-0 mt-3 ${isEdit ? "col-lg-7" : "col-lg-7"}`}>
                                                                <label className="table-cells">Bin Location</label>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control text-ellipsis" 
                                                                    value={(() => {
                                                                        // First try to get location from storage_locations (existing products)
                                                                        const storageLocation = item.storage_locations?.[0];
                                                                        if (storageLocation?.location?.[0]) {
                                                                            const loc = storageLocation.location[0];
                                                                            return `${loc.warehouse_name || ''} > ${loc.zone_name || ''} > ${loc.rack_name || ''} > ${loc.bin_name || ''}`;
                                                                        }
                                                                        
                                                                        // Then try to get location from direct location array (newly added products)
                                                                        if (item.location && item.location.length > 0) {
                                                                            const loc = item.location[0];
                                                                            return `${loc.warehouse_name || ''} > ${loc.zone_name || ''} > ${loc.rack_name || ''} > ${loc.bin_name || ''}`;
                                                                        }
                                                                        
                                                                        return 'No location assigned';
                                                                    })()} 
                                                                    readOnly 
                                                                    disabled 
                                                                    title={(() => {
                                                                        // First try to get location from storage_locations (existing products)
                                                                        const storageLocation = item.storage_locations?.[0];
                                                                        if (storageLocation?.location?.[0]) {
                                                                            const loc = storageLocation.location[0];
                                                                            return `${loc.warehouse_name || ''} > ${loc.zone_name || ''} > ${loc.rack_name || ''} > ${loc.bin_name || ''}`;
                                                                        }
                                                                        
                                                                        // Then try to get location from direct location array (newly added products)
                                                                        if (item.location && item.location.length > 0) {
                                                                            const loc = item.location[0];
                                                                            return `${loc.warehouse_name || ''} > ${loc.zone_name || ''} > ${loc.rack_name || ''} > ${loc.bin_name || ''}`;
                                                                        }
                                                                        
                                                                        return 'No location details available';
                                                                    })()}
                                                                />
                                                            </div> */}
                                                        </div>
                                                        {(() => {
                                                            const rowData = resolveSelectedLineItemForDisplay(item, selectedProducts);
                                                            const custBlock = getCustomizationsBlockFromLineItem(rowData);
                                                            const custRows = getVisibleCustomizationFieldsForDisplay(custBlock);
                                                            if (custRows.length === 0) return null;
                                                            return (
                                                                <div className="col-lg-12 mt-2">
                                                                    <div className="fw-medium table-cells small mb-2 mt-1">customizations:</div>
                                                                    <div className="row g-2 g-lg-3">
                                                                        {custRows.map((field, idx) => (
                                                                            <div
                                                                                className="col-12 col-sm-6 col-lg-6"
                                                                                key={`${String(rowData.product_id)}-${String(rowData.slot_id ?? "")}-cust-${String(field.field_name || idx)}`}
                                                                            >
                                                                                <div className="px-3 py-2 small text-break">
                                                                                    <span className="fs-14 fw-medium">{field.field_name || "Field"}</span>
                                                                                    <span className="text-muted"> : </span>
                                                                                    {(() => {
                                                                                        const v = String(field.value ?? "").trim();
                                                                                        const ft = String(field.field_type || "").toLowerCase();
                                                                                        const isFile = ft === "file" || ft === "image";
                                                                                        const m = (customizationImageUrlMap as Record<string, string>) || {};
                                                                                        const src =
                                                                                            isFile && /^[a-f0-9]{24}$/i.test(v)
                                                                                                ? m[v] || getImageSrc(v, m) || ""
                                                                                                : "";
                                                                                        if (src) {
                                                                                            return (
                                                                                                <img
                                                                                                    src={src}
                                                                                                    alt=""
                                                                                                    style={{
                                                                                                        maxHeight: 120,
                                                                                                        maxWidth: "100%",
                                                                                                        borderRadius: 8,
                                                                                                        border: "1px solid #dee2e6",
                                                                                                        display: "block",
                                                                                                        marginTop: 4,
                                                                                                    }}
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                        return <span className="fs-14">{String(field.value ?? "")}</span>;
                                                                                    })()}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>
                                            );
                                            };

                                            if (visibleProducts.length === 0) {
                                                return (
                                                    <div className="text-center text-muted py-4 border rounded-3">
                                                        No products added yet.
                                                    </div>
                                                );
                                            }

                                            return (
                                                <>
                                                    {inventoryProducts.length > 0 && (
                                                        <>
                                                            <div className="d-flex align-items-center gap-2 mb-3">
                                                                <span className="fw-semibold table-cells">Inventory Products</span>
                                                            </div>
                                                            {inventoryProducts.map(({ item, index }, i) =>
                                                                renderProductCard(item, index, i + 1, false)
                                                            )}
                                                        </>
                                                    )}
                                                    {purchasedProducts.length > 0 && (
                                                        <>
                                                            {inventoryProducts.length > 0 && <hr className="my-4" />}
                                                            <div className="d-flex align-items-center gap-2 mb-3">
                                                                <span className="fw-semibold table-cells">Purchased Products</span>
                                                            </div>
                                                            {purchasedProducts.map(({ item, index }, i) =>
                                                                renderProductCard(item, index, inventoryProducts.length + i + 1, true)
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </div>
                                    {pickerOpen && pickerUserType && pickerUserId && pickerSignageCompanyId && token ? (
                                        <RealtorProductPicker
                                            open={pickerOpen}
                                            onClose={() => setPickerOpen(false)}
                                            userType={pickerUserType}
                                            userId={pickerUserId}
                                            signageCompanyId={pickerSignageCompanyId}
                                            token={token}
                                            onAdd={handleAddFromPicker}
                                        />
                                    ) : null}
                                </div>
                                <div className="row col-lg-12 mb-3">
                                    <div className="col-lg-6 mb-3 mb-lg-0 pe-0">
                                        <Instructions
                                            title="Instructions"
                                            mode="instructions_files"
                                            loginType={installationOrder?.status === 100 ? "signage" : "agent"}
                                            instructions={instructions}
                                            attachments={instructionAttachments}
                                            orderDocumentId={String(installationOrder?._id || installationOrder?.id || installationId || "")}
                                            collectionName="installation"
                                            placeholder="Add instructions here"
                                            rows={4}
                                            onSave={handleSaveInstructionsOnly}
                                            onAfterFilesUploaded={fetchOrderDetails}
                                            className="mb-3"
                                            iconColor="#f54a00"
                                            iconBackground="#EAF7F1"
                                        />

                                    </div>

                                    <div className="align-items-center card-body col-lg-5 justify-content-end ms-0 ms-2 ms-lg-0 ms-lg-5 offset-1 p-4 shadow-lg">
                                        <div className="align-items-center d-flex mb-3">
                                            <span
                                                aria-hidden="true"
                                                className="image-icons"
                                                style={{
                                                    backgroundColor: "#00a63e",
                                                    WebkitMaskImage: `url(${Doller})`,
                                                    maskImage: `url(${Doller})`,
                                                }}
                                            />
                                            <SectionHeader title="Cost Breakdown" icon="" color="" size="lg" divider />
                                        </div>

                                        {!Viewmode && (
                                            <OrderDiscountCodeField
                                                className="mb-2"
                                                value={couponInput}
                                                appliedCode={discountDisplay.code}
                                                discountAmount={discountDisplay.amount}
                                                voucherApplied={
                                                    discountDisplay.amount > 0 &&
                                                    Boolean(discountDisplay.code.trim())
                                                }
                                                disabled={isRecomputing}
                                                error={couponResolveError}
                                                onChange={setCouponInput}
                                                onApply={(code) => {
                                                    void applyDiscountCode(code);
                                                }}
                                                onClear={() => {
                                                    void clearDiscountCode();
                                                }}
                                            />
                                        )}
                                        {zeroOrNegativeMsg && <div className="text-danger mt-2">{zeroOrNegativeMsg}</div>}
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Units Purchased:</span>
                                            <span className="fw-semibold">{unitsPurchased}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Total Units:</span>
                                            <span className="fw-semibold">{totalUnits}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Installation Cost:</span>
                                            <span className="fw-semibold">${Number(installationCost || 0).toFixed(2)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Units Cost:</span>
                                            <span className="fw-semibold">
                                                ${(unitsCost ?? 0).toFixed(2)}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Sub-total:</span>
                                            <span className="fw-semibold">
                                                ${(Number(installationCost || 0) + Number(unitsCost || 0)).toFixed(2)}
                                            </span>
                                        </div>
                                        {/* {(installationOrder?.discount_code || installationOrder?.discount_amount) && (

                                            <div className="d-flex justify-content-between align-items-center py-2">
                                                <span className="fw-medium" style={{ color: "#00a63e" }}>Discount({installationOrder?.discount_code})</span>
                                                <span className="fw-semibold text-success" style={{ color: "#00a63e" }}>
                                                    -${Number(installationOrder?.discount_amount || 0).toFixed(2)}
                                                </span>
                                            </div>
                                        )} */}
                                        {(formik.values?.discount_code && Number(getEffectiveDiscountAmount()) > 0) && (
                                            <div className="d-flex justify-content-between align-items-center py-2">
                                                <span className="fw-medium" style={{ color: "#00a63e" }}>Discount ({formik.values?.discount_code || "—"}):</span>
                                                <span className="fw-semibold text-success" style={{ color: "#00a63e" }}>
                                                    -${Number(getEffectiveDiscountAmount()).toFixed(2)}
                                                </span>
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            {(() => {
                                                const { labelText, tooltip } = buildSpecialFeeCostBreakdownDisplay(selectedSpecialFees);
                                                return (
                                                    <>
                                                        <span className="fw-medium me-2" style={{ minWidth: 0 }} title={tooltip}>
                                                            {labelText}:
                                                        </span>
                                                        <span className="fw-semibold flex-shrink-0">
                                                            ${Number(formik.values.totals.specialfee_subtotal || 0).toFixed(2)}
                                                        </span>
                                                    </>
                                                );
                                            })()}
                                        </div>

                                        <div className="py-1">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <button
                                                    type="button"
                                                    onClick={() => setShowTaxDetails(v => !v)}
                                                    className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center"
                                                    aria-expanded={showTaxDetails}
                                                    aria-controls="tax-breakdown"
                                                >
                                                    {/* <i className={`bi ${showTaxDetails ? "bi-chevron-down" : "bi-chevron-right"} me-1`} /> */}
                                                    <span className="order-card-title">Tax :</span>
                                                </button>
                                                <span className="order-card-cells">
                                                    <span>
                                                        ${(
                                                            Number(formik.values.totals.installation_tax_amount || 0) +
                                                            Number(formik.values.totals.specialfee_tax_amount || 0) +
                                                            Number((formik.values.totals as any)?.product_tax_amount || 0)
                                                        ).toFixed(2)}
                                                    </span>
                                                </span>
                                            </div>

                                            {showTaxDetails && (
                                                <div id="tax-breakdown" className="border rounded-3 p-2 bg-light mt-1">
                                                    <div className="d-flex justify-content-between small mb-1">
                                                        <span>Installation Tax</span>
                                                        <span className="order-card-cells">
                                                            ${Number(formik.values.totals?.installation_tax_amount || 0).toFixed(2)}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small mb-1">
                                                        <span>Product Tax</span>
                                                        <span className="order-card-cells">
                                                            ${Number((formik.values.totals as any)?.product_tax_amount || 0).toFixed(2)}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span>Special Fee Tax</span>
                                                        <span className="order-card-cells">
                                                            ${Number(formik.values.totals?.specialfee_tax_amount || 0).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <hr className="my-3" />

                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-bold fs-5">Total Amount:</span>
                                            <span className="fw-bold fs-5 text-primary">
                                                ${TotalAmount}
                                            </span>
                                        </div>

                                        <hr className="my-3" />

                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Already Paid:</span>
                                            <span className="fw-semibold">${totalPaid.toFixed(2)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <span className="fw-medium">Remaining Balance:</span>
                                            <span className="fw-semibold">
                                                {installationOrder?.payment_status === "Overpaid"
                                                    ? `+$${Math.abs(remaingamount).toFixed(2)}`
                                                    : `$${remaingamount.toFixed(2)}`
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Proof of Installation Section - Read Only for Agents */}
                                <div className="row col-lg-12 mb-3">
                                    <div className="mb-3">
                                        {(installationOrder?.status === 500 || installationOrder?.status === 600) && (
                                            <ProofSection
                                                title="Proof of Installation"
                                                canEdit={false}  // Read-only for agents
                                                existing={uploadedFileMeta}
                                                setExisting={setUploadedFileMeta}
                                                onSubmitProof={async (newFiles) => {
                                                    // No-op for agents since canEdit is false
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-3 col-lg-12 rcust-margin-4 d-none d-lg-block" style={{ marginTop: "27px" }}>
                                    <div className="col-lg-12 d-block d-lg-flex justify-content-between">
                                        <div className="col-lg-2 mb-3">
                                            <button
                                                type="button"
                                                onClick={() => safeNavigate(`/agent/jobs/installations`)}
                                                className="btn back-btn surface-btn fw-bold fs-16 w-100"
                                            >
                                                <i className="bi bi-chevron-left me-2" />
                                                Back
                                            </button>
                                        </div>

                                        <div className="align-items-baseline col-lg-3 d-lg-flex justify-content-end">
                                            {/* {!isEdit && (installationOrder?.status !== 200) && (
                                                <>
                                                    <button
                                                        className="btn btn-primary actionbuttons"
                                                        type="submit"
                                                        disabled={
                                                            formik.isSubmitting ||
                                                            !formik.values.localLawsChecked ||
                                                            (installationOrder?.status === 100 && (installationOrder?.payment_info?.length ?? 0) === 0)
                                                        }

                                                    >
                                                        Pay & Confirm
                                                    </button>
                                                </>
                                            )} */}
                                            {isEdit && (
                                                <button
                                                    className="btn btn-primary save-btn surface-btn fw-bold fs-16"
                                                    type="submit"
                                                    disabled={formik.isSubmitting}
                                                >
                                                    Save
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <PONumber
                                    title="PO Number"
                                    value={String((installationOrder as any)?.po_number ?? (installationOrder as any)?.poNumber ?? "")}
                                    placeholder="e.g. PO-2026-00124"
                                    className="mb-3"
                                    orderId={String(installationOrder?._id || installationOrder?.id || installationId || "")}
                                    orderType="installation"
                                    onSaved={async () => {
                                        await fetchOrderDetails();
                                    }}
                                />
                                <SpecialFeeui
                                    token={token!}
                                    personId={installationOrder?.agent_id || userId || ""}
                                    supplierId={resolveInstallationSellerOrganizationId(
                                        installationOrder?.seller_org_id,
                                        installationOrder
                                    )}
                                    order={installationOrder}
                                    orderId={String(installationOrder?._id || installationOrder?.id || installationId || "").trim()}
                                    orderType="installation"
                                    formik={formik}
                                    name="specialFees"
                                    value={selectedSpecialFees} // âœ… Pass state directly instead of relying on Formik
                                    disabled={isRecomputing}  // âœ… Disable special fee selection when recompute is running
                                    onOptionsLoaded={(allOptions) => {
                                        // âœ… Receive all available fees (including required field) from component
                                        setAllAvailableSpecialFees(allOptions);
                                        // console.log("All available special fees from component:", allOptions);
                                    }}
                                    onUserChange={(nextFees) => {
                                        // âœ… Don't process if recompute is running (prevents duplicate calls)
                                        if (isRecomputingRef.current) {
                                            safeConsole.log("â¸ï¸ Recompute in progress, skipping special fee change");
                                            return;
                                        }

                                        // âœ… Update state first (primary source)
                                        setSelectedSpecialFees(nextFees);
                                        // Also update Formik for form submission
                                        formik.setFieldValue("specialFees", nextFees, false);
                                        // Trigger recompute
                                        triggerRecomputeWith({ fees: nextFees });
                                    }}
                                    readOnly={!isEdit}
                                />
                                {
                                    installationOrder?.payment_status === "Paid" ? <></> :
                                        <div className="col-lg-12 mb-3">
                                            {installationOrder?.status !== 600 && Viewmode && (
                                                <PaymentPanel
                                                    variant="agent"   // or brokerage/agent depending on type
                                                    remainingAmount={Number(remaingamount)}
                                                    orderStatus={installationOrder?.status ?? 0}
                                                    paymentStatus={installationOrder?.payment_status ?? ""}
                                                    selectedPaymentMethod={selectedPaymentMethod}
                                                    setSelectedPaymentMethod={setSelectedPaymentMethod}
                                                    formik={formik}
                                                    maxAllowed={maxAllowed}
                                                    paymentInfo={installationOrder?.payment_info ?? []}
                                                    dynamicMethods={paymentMethod} // [{ _id, name }]
                                                    onSubmitOffline={(key) => completeOrder(key)}
                                                    orderType="installationOrder"
                                                    onlinePaymentNode={
                                                        stripePromise && clientSecret ? (
                                                            <Elements key={clientSecret} stripe={stripePromise} options={{ clientSecret }}>
                                                                <PaymentFormManualOrder
                                                                    url="installation_orders"
                                                                    method="POST"
                                                                    supplierId={
                                                                        resolveInstallationSellerOrganizationId(
                                                                            installationOrder?.seller_org_id,
                                                                            installationOrder
                                                                        ) ||
                                                                        String(installationOrder?.seller_org_id || "").trim()
                                                                    }
                                                                    totalAmount={remaingamount ? remaingamount : installationOrder?.total_amount}
                                                                    paidAmount={
                                                                        formik.values.partial_amount === 0
                                                                            ? (Number(installationOrder?.total_amount || 0) - totalPaid)
                                                                            : formik.values.partial_amount
                                                                    }
                                                                    orderId={String(installationOrder?._id || installationOrder?.id || "")}
                                                                    orderNumber={String(installationOrder?.order_number || "")}
                                                                    customerName={String(installationOrder?.user_name || "")}
                                                                    customerPhone={String(installationOrder?.user_phone || "")}
                                                                    selectedPaymentMethod={selectedPaymentMethod?.name || "online"}
                                                                    skipRedirectOnSuccess
                                                                    onPaymentSuccess={async () => {
                                                                        localStorage.removeItem("cart_id");
                                                                        safeNavigate(0);
                                                                    }}
                                                                    userId={resolveInstallationPaymentMethodsMembershipId(installationOrder)}
                                                                    userEmail={installationOrder?.user_email}
                                                                    paidBy_id={userId?.toString() ?? ""}
                                                                    paidBy_name={userName ?? ""}
                                                                    payments_status={installationOrder?.payment_status ?? ""}
                                                                    onPaymentEmailCallback={sendInstallationPaymentAppliedEmails}
                                                                />
                                                            </Elements>
                                                        ) : null
                                                    }
                                                    paymentMethodsNode={
                                                        (() => {
                                                            const userIdForPayment = resolveInstallationPaymentMethodsMembershipId(installationOrder);
                                                            return (
                                                                <PaymentMethods orderId={installationOrder?._id || ""} totalAmount={remaingamount ? remaingamount : installationOrder?.total_amount || 0} supplierId={installationOrder?.seller_org_id || ""} id={userIdForPayment || ""} ordertype="installationOrder" paymentInfo={installationOrder?.payment_info || []}
                                                                />
                                                            );
                                                        })()
                                                    }
                                                />
                                            )}
                                        </div>
                                }

                                <div className="col-lg-12 rounded-3 mb-3">
                                    <OrderLog
                                        title="Installation Log"
                                        orderKind="installation"
                                        events={installationLogEvents}
                                    />
                                </div>
                            </div>
                            {/* for mobile and tab view back and submit button */}
                            <div className="row mb-3 col-lg-12 rcust-margin-4 d-block d-lg-none">
                                <div className="col-lg-12 d-block d-lg-flex justify-content-between">
                                    <div className="col-lg-2 mb-3">
                                        <button
                                            type="button"
                                            onClick={() => safeNavigate(`/agent/jobs/installations`)}
                                            className="btn back-btn surface-btn fw-bold fs-16 w-100"
                                        >
                                            <i className="bi bi-chevron-left me-2" />
                                            Back
                                        </button>
                                    </div>

                                    <div className="align-items-baseline col-lg-3 d-lg-flex justify-content-end">
                                        {/* {!isEdit && (installationOrder?.status !== 200) && (
                                            <>
                                                <button
                                                    className="btn btn-primary actionbuttons"
                                                    type="submit"
                                                    disabled={
                                                        formik.isSubmitting ||
                                                        !formik.values.localLawsChecked ||
                                                        (installationOrder?.status === 100 && (installationOrder?.payment_info?.length ?? 0) === 0)
                                                    }

                                                >
                                                    Pay & Confirm
                                                </button>
                                            </>
                                        )} */}
                                        {isEdit && (
                                            <button
                                                className="btn btn-primary actionbuttons"
                                                type="submit"
                                                disabled={formik.isSubmitting}
                                            >
                                                Save
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <AddressFormModal
                                            isOpen={showAddressForm}
                                            onClose={() => {
                                              setShowAddressForm(false);
                                            }}
                                            token={token || ""}
                                            owner={selectedOfficeAgent || selectedAgent || selectedOffice}
                                            useType="billing"
                                            prefill={{
                                              // Prefill from your existing parent formik values (same field names you used)
                                              label_of_address: formik.values.label_of_address || "",
                                              firstName: formik.values.firstName || "",
                                              lastName: formik.values.lastName || "",
                                              company: formik.values.company || "",
                                              phone: formik.values.phone || "",
                                              addressLine1: formik.values.addressLine1 || "",
                                              addressLine2: formik.values.addressLine2 || "",
                                              city: formik.values.city || "",
                                              state: formik.values.state || "",
                                              zipcode: formik.values.zipcode || "",
                                              country: formik.values.country || "",
                                            }}
                                            onCreated={(createdRaw, option, useType) => {
                                              setAddressObjects((prev) => [createdRaw, ...(prev || [])]);
                                              formik.setFieldValue(
                                                useType === "billing" ? "billingAddressId" : "shippingAddressId",
                                                option.value
                                              );
                                              const isOffice =
                                                !!selectedOffice &&
                                                !selectedOfficeAgent &&
                                                !selectedAgent;

                        
                                              if (useType === "billing") {
                                                if (isOffice) {
                                                  setSelectedOfficeBillingAddress(createdRaw);
                                                } else {
                                                  setSelectedBillingAddress(createdRaw?.address_details || null);
                                                }
                                              } else {
                                                if (isOffice) {
                                                  setSelectedOfficeShippingAddress(createdRaw);
                                                } else {
                                                  setSelectedShippingAddress(createdRaw?.address_details || null);
                                                }
                                              }
                        
                                              // 4) Mirror to shipping if same-as-billing is checked
                                              if (useType === "billing" && formik.values.isSameAsBilling) {
                                                formik.setFieldValue("shippingAddressId", option.value);
                                                if (isOffice) {
                                                  setSelectedOfficeShippingAddress(createdRaw);
                                                } else {
                                                  setSelectedShippingAddress(createdRaw?.address_details || null);
                                                }
                                              }
                                            }}
                                            afterCreateRefresh={() => {
                                              // Call your existing refreshers (you already have these funcs)
                                              if (selectedOfficeAgent) return fetchUserAddresses(selectedOfficeAgent);
                                              if (selectedAgent) return fetchUserAddresses(selectedAgent);
                                              if (selectedOffice) return fetchOfficeAddresses(selectedOffice);
                                            }}
                                          /> */}
                    </form>

                </div>
            </div >
        </div >
    );
};

export default AgentViewInstallation;